import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter, Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import moment from "moment";
import {
  PRAGATI_ISSUE_WITH_RECIPIENT as filtersDropDown,
  PATHS,
  ERROR_MSG,
  STATUS,
  REDIRECTION_DASHBOARD_URLS,
  getDashBoardOpenProjectGroupCategoryPayload,
  ISSUE_STAGES_STATE,
  ISSUE_STAGES_CENTRAL
} from "../../constant";
import {
  setLocalstorage,
  getLocalstorage,
  dateFormat,
  isValidArray,
  sortBy,
  scrollToPosition,
  dateFormatWithTime,
  getColor,
  formatNumberOnDashBoard,
  formatNumber
} from "../../helper";
import {
  Form,
  Image,
  Button,
  Col,
  Card,
  Row,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import Graph from "./Graph";
import CalendarFilter from "../calendarFilter/CalendarFilter";
import "react-perfect-scrollbar/dist/css/styles.css";
import Notification from "../notification/Notification";
import {
  MeetingLoaderTemplate,
  SideBarListingTemplate,
  IssuePendingLoader,
  IssueCategoryLoader
} from "../../component/LoadersTemplate";
import LoaderTemplate from "../../component/LoaderTemplate";
import TableLoaderTemplate from "../../component/TableLoaderTemplate";
import { ToggleBtn } from "../togglebtn";
import { DASHBOARD_CALENDER } from "../../constant";
import { FirstPage } from "../mis/charts/firstPage/index";
import { SecondPage } from "../mis/charts/secondPage/index";
import { FourthPage } from "../mis/charts/fourthPage/index";
import projectMonitored from "../../assets/frontPageIcons/project-monitor.png";
import projectValue from "../../assets/frontPageIcons/cost.png";
import issueMonitored from "../../assets/frontPageIcons/research.png";
import pragati from "../../assets/frontPageIcons/pragati.png";
import Slider from "react-slick";
import { Dropdown } from "primereact/dropdown";
import {
  getWorkflowStatesAction,
  getDashboardSummary,
  getProjectsByScheme,
  getIssuesByCategory,
  getIssuesByCategoryForGanttChart,
  getPendingIssuesBy,
  getProjectsBy,
  getProjectsByLocation,
  fetchMeetings,
  getDashboardNotifications,
  dashboardPendingTask,
  PendingTaskResolvedComment,
  getPragatiProjectList,
  getDashboardUpcomingMeetings,
  getChildGroupIssuesData,
  getDashboardPendingTasksAction,
  getShowSponsorRecipientFilterAction,
  showTeamSection,
  getDelayedProjectsList,
  getProjectsCostOverRunList,
  getPmgMeetingStatusAction,
  getShowStateAndCentralFilterAction
} from "../../actions/dashboard.action";
import { getIssueList } from "../../actions/common.action";
import { get, groupBy } from "lodash";
import PermissionHoc from "../PermissionHOC";
import { toast } from "react-toastify";
import NoDataFound from "../../component/NoDataFound";
import { LoaderPage } from "../../component/Loader";
import {
  DownloadExcelReport,
  Cards,
  CustomDropDown
} from "../reusableComponent";
import {
  getDownloadDashboardSummaryAction,
  clearDashboardSummaryAction,
  downloadWeeklyReportForStatePmg,
  clearWeeklyReportForStatePmgAction,
  uploadMeetingTableAction,
  getMeetingTableAction,
  downloadMarch24ReportExcelAction,
  clearDownloadMarch24ReportExcelAction
} from "../../actions/dowloadExcelActions";

import { GroupSection } from "./groupSection";
import DisplayByPermission from "../../component/DisplayByPermission";
import CountUp from "react-countup";
import { Title } from "./dashboard.constant";
import {
  _getProjectsByCompletionStageAction,
  getProjectsByCompletionStageAction
} from "../../actions/reports.action";
import MeetingTable from "../mis/charts/fourthPage/meetingTable";
import { UploadCSVComponent } from "../../component/UploadCSVFile";
import { successToastStyle, errorToastStyle } from "../../customToast";
import {
  toolttipDisplayMessage,
  getIssueAssigneeDate
} from "../issueList/helper";
import calBlank from "../../assets/cal-blank.svg";
import clockCal from "../../assets/clockCal.svg";
import Meeting from "../../assets/meeting.svg";
import ChairedBy from "../../assets/created-by.svg";
import ZoomLevelProvider from "../projectList/ZoomLevelProvider";
import CustomDropdown from "../reusableComponent/Dropdown/CustomDropdown";
import Approve from "../reusableComponent/ministry/Approve";
import ModifyAndApprove from "../reusableComponent/ministry/modifyAndApprove";
import { getDashboardPendingTasks } from "../../services/apiServices";
import request from "../../services/requestService";
import IconTime from "../../assets/icon-time.svg";
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectStatusSelect: "VERIFIED",
      projectLocationStatusSelect: "VERIFIED",
      projectLocationGroupCategorySelect: "CENTRAL",
      projectGroupCategorySelect: "CENTRAL",
      delayedProjectModeSelect: "All",
      //pendingTaskZoneSelect: null,
      pendingTaskZoneSelect: "0",
      meetingDate: new Date(),
      issuesStatusSelect: "UNDER_PROCESS",
      issuesStatusSelectText: "Pending with RM/RS",
      issuesGroupCategorySelect: "CENTRAL",
      pragatiProjectSelectBy: "CENTRAL",
      issuesByCategorySelectBy: "CENTRAL",
      issuesGroupCategorySelectText: "",
      filterArray: {
        limit: 0,
        offset: 0
      },
      pendingTask: [],
      resolveToggle: false,
      error: {},
      commentConfirmStatus: false,
      pendingTaskStatus: true,
      sortProjectOrder: "asc",
      sortProjectLocationOrder: "asc",
      sortTotalIssue: "asc",
      sortProjectScheme: "asc",
      sortIssueCategoryCount: "asc",
      delayedProjectDataSortkey: "",
      taskStatus: false,
      showLoader: false,
      recipientFilter: false,
      summaryDataBy: false,
      workflowStates: [],
      displayDateTitle: "All",
      updateValues: 0,
      myNotificationData: [],
      costOverrunProjectModeSelect: "All",
      costOverrunProjectDataSortkey: "",
      sortRecipientKey: "",
      meetingTableStatus: false,
      meetingTableData: {},
      uploadMeetingTableStatus: false,
      isChecked: false,
      checkedValue: false,
      stateAndCentralFilter: false,
      stateAndCentralFilterChecked: false,
      stateAndCentralProjectSelectedBy: "CENTRAL",
      sponsorGroupCategoryName: "Ministry",
      issuesGroupCategoryName: "Ministry/State",
      locationGroupCategoryName: "State",
      pragatiGroupCategoryName: "Ministry",
      march24D: false,
      zoomPercentage: 100,
      implementationMode: [
        { name: "All", value: "All" },
        { name: "Public", value: "PUBLIC" },
        { name: "Private", value: "PRIVATE" },
        { name: "PPP", value: "PPP" },
        { name: "NA", value: "NA" }
      ],
      zoneOptions: [
        // { label: "All", value: "" },
        { label: "All Zones", value: "0" },
        { label: "Central Zone", value: "1" },
        { label: "East Zone", value: "2" },
        { label: "North Zone", value: "3" },
        { label: "Northeast Zone", value: "4" },
        { label: "South Zone", value: "5" },
        { label: "West Zone", value: "6" }
      ],
      panelKey: 0,
      prgatiProjectStatusSelect: "",
      isOpen: false,
      selected: "All",
      hoverItem: null,
      projectStatus: [
        { value: "CENTRAL", label: "Central" },
        { value: "STATE", label: "State" }
      ],
      projectLocationDropdown: [
        { value: "CENTRAL", label: "Central" },
        { value: "STATE", label: "State" }
      ],
      activeTab: "projects",
      pendingComments: [],
      pendingCommentsStatus: true
    };
    this.dropdownRef = createRef();
  }

  componentDidMount = async () => {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.fetchApi();
  };
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = event => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ isOpen: false });
    }
  };

  toggleDropdown = () => {
    this.setState(prev => ({ isOpen: !prev.isOpen }));
  };
  handleTabChange = tab => {
    this.setState({ activeTab: tab });
  };
  handleSelect = option => {
    this.setState({
      selected: option.displayName,
      isOpen: false,
      hoverItem: null
    });
    // if (this.props.onChange) this.props.onChange(displayName);
  };

  handleMouseEnter = displayName => {
    this.hovered = displayName;
    this.forceUpdate(); // triggers quick re-render (faster than setState)
  };

  handleMouseLeave = () => {
    this.hovered = null;
    this.forceUpdate();
  };
  fetchApi = () => {
    setLocalstorage("projectResponse", null);
    setLocalstorage("issueList", null);
    scrollToPosition({ top: 0 });
    const {
      getDashboardSummary,
      getIssuesByCategory,
      getIssuesByCategoryForGanttChart,
      getPendingIssuesBy,
      getDashboardNotifications,
      getProjectsBy,
      getProjectsByLocation,
      permission,
      getDashboardUpcomingMeetings,
      getChildGroupIssuesData,
      getDashboardPendingTasksAction,
      showTeamSection,
      _getProjectsByCompletionStageAction,
      getPmgMeetingStatusAction
    } = this.props;
    const {
      projectStatusSelect,
      projectLocationStatusSelect,
      stateAndCentralProjectSelectedBy
    } = this.state;
    const checkedValue = getLocalstorage("march24");
    const issueDefaultPayload = {
      groupCategory: "CENTRAL",
      status: "UNDER_PROCESS",
      march24: checkedValue
    };
    const projectDefaultPayload = {
      groupCategory: "CENTRAL",
      status: projectStatusSelect,
      march24: checkedValue
    };

    const issueByCategoryPayload = {
      groupCategory: "CENTRAL",
      march24: checkedValue
    };

    const issueByCategoryGanttChartPayload = {
      // groupCategory: "CENTRAL",
      march24: checkedValue
    };

    const projectByLocationDefaultPayload = {
      groupCategory: "CENTRAL",
      status: projectLocationStatusSelect,
      march24: checkedValue
    };

    const user = getLocalstorage("user");
    const userGroupCategory =
      user.groupCategory === "DISTRICT" ||
      user.groupCategory === "STATE_DEPARTMENT";
    if (user.groupCategory === "STATE") {
      setLocalstorage("summaryType", "CENTRAL");
    } else if (user.groupCategory === "STATE_PMG") {
      setLocalstorage("summaryType", "CENTRAL");
    } else if (user.groupCategory === "CENTRAL") {
      if (getLocalstorage("summaryType") !== null) {
        setLocalstorage("summaryType", getLocalstorage("summaryType"));
      } else {
        setLocalstorage("summaryType", "SPONSOR");
      }
    }

    const userSponsoredScheme = getLocalstorage("userSponsoredScheme");
    this.getMeetingTableData();
    if (!get(user, "projectCreatedBy") && get(user, "groupCategory") === "PP") {
      this.props.history.push(PATHS.CREATE_PROJECT);
    } else {
      const { filterArray } = this.state;
      // getDashboardSummary(undefined, filterArray);
      getPendingIssuesBy(undefined, issueDefaultPayload);
      getProjectsByLocation(undefined, projectByLocationDefaultPayload);
      getProjectsBy(undefined, projectDefaultPayload);
      !get(permission, "dashboardMeetings") &&
        getDashboardUpcomingMeetings(undefined, checkedValue);
      this.fetchGetPragatiProject();
      this.fetchDelayedProjects();
      getIssuesByCategory(undefined, issueByCategoryPayload);
      getIssuesByCategoryForGanttChart(
        undefined,
        issueByCategoryGanttChartPayload
      );
      getChildGroupIssuesData(undefined, checkedValue);
      const falseD = false;
      const centralDa =
        get(user, "groupCategory") === "STATE_PMG" ||
        get(user, "groupCategory") === "STATE" ||
        get(user, "groupCategory") === "DISTRICT" ||
        get(user, "groupCategory") === "STATE_DEPARTMENT"
          ? this.state.stateAndCentralProjectSelectedBy
          : "";
      //const data = { falseD, centralDa };
      const data = {
        falseD,
        centralDa,
        zoneId: this.state.pendingTaskZoneSelect
      };
      getDashboardPendingTasksAction(undefined, data);
      showTeamSection();
      this.fetchMeetingsData(checkedValue);
      this.handlePendingTask();
      this.handlegetDashboardPendingTasks();
      this.getWorkflowStates();
      this.fetchCostOverrunProjects();
      getPmgMeetingStatusAction();
      _getProjectsByCompletionStageAction(undefined, checkedValue);

      getShowStateAndCentralFilterAction().then(resp => {
        try {
          if (
            resp.data ||
            getLocalstorage("groupCategory") == "STATE_PMG" ||
            getLocalstorage("groupCategory") == "STATE"
          ) {
            this.setState({
              stateAndCentralFilter: resp.data || true
            });
          }
        } catch (error) {}
      });

      getShowSponsorRecipientFilterAction().then(resp => {
        try {
          let params = { ...filterArray, march24: checkedValue };
          if (userGroupCategory) {
            params.groupCategory = stateAndCentralProjectSelectedBy;
          }
          if (resp.data) {
            let type = getLocalstorage("summaryType")
              ? getLocalstorage("summaryType")
              : "CENTRAL";
            if (
              getLocalstorage("groupCategory") == "STATE_PMG" ||
              getLocalstorage("groupCategory") == "STATE"
            ) {
              this.setState({ recipientFilter: false });
            } else this.setState({ recipientFilter: true });
          }
          if (
            getLocalstorage("groupCategory") == "STATE_PMG" ||
            getLocalstorage("groupCategory") == "STATE"
          ) {
            params = {
              ...params,
              groupCategory: getLocalstorage("summaryType")
                ? getLocalstorage("summaryType")
                : "CENTRAL"
            };
            getDashboardSummary(undefined, params);
          } else if (this.state.recipientFilter) {
            params = {
              ...params,
              type: getLocalstorage("summaryType")
                ? getLocalstorage("summaryType")
                : "SPONSOR"
            };
            getDashboardSummary(undefined, params);
          } else {
            getDashboardSummary(undefined, params);
          }
        } catch (error) {}
      });
    }
    window && window.addEventListener("scroll", this.onDashboardScroll);
  };

  onDashboardScroll = () => {
    let currentOffset = (window && window.scrollY) || 0;
    if (
      currentOffset === 200 ||
      currentOffset === 250 ||
      (currentOffset > 550 && currentOffset < 650)
    ) {
      this.setState({
        updateValues: Math.random()
      });
    }
  };

  handlePendingTask = async () => {
    // const { getDashboardNotifications } = this.props;
    this.setState({
      pendingTaskStatus: true
    });
    let response = await dashboardPendingTask();

    if (response && response.status) {
      this.setState({
        pendingTask: get(response, "data.data", []),
        pendingTaskStatus: false
      });
    }
  };
  getAllComments = data => {
    if (data == "comment") {
      this.handlegetDashboardPendingTasks();
    }
  };
  displayLoader = data => {
    if (data) {
      this.setState({ showLoader: true });

      setTimeout(() => {
        this.setState({ showLoader: false });
      }, 1500);
    }
  };
  handlegetDashboardPendingTasks = async () => {
    this.setState({
      pendingCommentsStatus: true
    });
    let response = await request(
      getDashboardPendingTasks({ falseD: "false", centralDa: "CENTRAL" })
    );

    if (response && response.status) {
      this.setState({
        pendingComments: get(response, "data.data.pendingComments", []),
        pendingCommentsStatus: false
      });
    }
  };
  pendingTaskResolveToggle = id => {
    this.setState(prevState => ({
      commentId: prevState.commentId === id ? null : id
    }));
  };

  handleChange = (value, name) => {
    this.setState({ [name]: value });
  };
  fontSize = zoomPercentage => {
    if (zoomPercentage == 100) {
      return "8.5px";
    } else {
      return "9px";
    }
  };
  paddingLeft = zoomPercentage => {
    if (zoomPercentage == 100) {
      return "3px";
    } else {
      return "5px";
    }
  };
  padding = zoomPercentage => {
    if (zoomPercentage == 100) {
      return "7px 4px 7px 4px";
    } else {
      return "7px 6px 7px 6px";
    }
  };
  onError = (key, value) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };

  validateError = () => {
    const { comment } = this.state;
    if (comment) {
      this.setState(prevState => ({
        showAlert: !prevState.showAlert
      }));
    } else {
      this.setState({
        error: {
          comment: {
            error: !comment,
            message: !comment && ERROR_MSG.DEFAULT_MSG
          }
        }
      });
    }
  };

  onSubmit = async () => {
    this.setState({ showLoader: true });
    const { comment, commentId } = this.state;
    let response = await PendingTaskResolvedComment(undefined, {
      resolveComment: comment,
      id: commentId
    });

    const { status, data } = response || {};
    const { message } = data || {};
    status
      ? toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )
      : toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
    if (status) {
      this.handlePendingTask();
    }
    this.setState(prevState => ({
      comment: "",
      showLoader: false,
      showAlert: !prevState.showAlert
    }));
  };

  onStopSubmit = () => {
    this.setState(prevState => ({
      resolveToggle: false,
      comment: "",
      showAlert: !prevState.showAlert
    }));
  };

  fetchCostOverrunProjects = params => {
    // const { costOverrunProjectModeSelect } = this.state;
    const { costOverrunProjectModeSelect } = "";
    const march24 = getLocalstorage("march24");
    let data = { costOverrunProjectModeSelect, march24 };

    this.props.getProjectsCostOverRunList(undefined, data);
  };

  fetchMeetingsData = async checkedValue => {
    const { fetchMeetings } = this.props;
    const { meetingDate } = this.state;
    await fetchMeetings(undefined, meetingDate * 1, checkedValue);
  };
  onSelectChangeDropdown = (value, name) => {
    this.setState({ projectGroupCategorySelect: value }, () => {
      if (
        name === "projectStatusSelect" ||
        name === "projectGroupCategorySelect"
        // || name === "projectLocationGroupCategorySelect"
      ) {
        const { projectStatusSelect, projectGroupCategorySelect } = this.state;
        const checkedValue = getLocalstorage("march24");
        this.props.getProjectsBy(undefined, {
          groupCategory: projectGroupCategorySelect,
          status: projectStatusSelect,
          march24: checkedValue
        });
        // this.fetchProjectsBy();
        let sponsorCategoryName;
        if (name === "projectGroupCategorySelect") {
          sponsorCategoryName =
            value === "CENTRAL" ? "Ministry Name" : "Department";

          this.setState({
            sponsorGroupCategoryName: sponsorCategoryName
          });
        }
      }
    });
  };
  onSelectChangeLocation = (value, name) => {
    this.setState({ projectLocationGroupCategorySelect: value }, () => {
      if (
        name === "projectLocationStatusSelect" ||
        name === "projectLocationGroupCategorySelect"
      ) {
        this.fetchProjectsByLocation();
        if (name === "projectLocationGroupCategorySelect") {
          let locationCategoryName = value === "CENTRAL" ? "State" : "District";

          this.setState({
            locationGroupCategoryName: locationCategoryName
          });
        }
      }
    });
  };
  onSelectChangePragatiProject = (value, name) => {
    this.setState({ pragatiProjectSelectBy: value }, () => {
      if (
        name === "pragatiProjectSelectBy" ||
        name === "prgatiProjectStatusSelect"
      ) {
        this.fetchGetPragatiProject(this.state.prgatiProjectStatusSelect);
        if (name === "pragatiProjectSelectBy") {
          let paragtiCategoryName =
            value === "CENTRAL" ? "Ministry" : "Department";

          this.setState({
            pragatiGroupCategoryName: paragtiCategoryName
          });
        }
      }
    });
  };
  onSelectChangeIssuePendingCategory = (value, name) => {
    this.setState({ issuesByCategorySelectBy: value }, () => {
      if (name === "issuesByCategorySelectBy") {
        this.fetchIssuesByCategory();
      }
    });
  };
  onSelectChangeIssueGroup = (value, name) => {
    const { workflowStates } = this.state;
    let firstItem = null;
    let params = {};
    const checkedValue = getLocalstorage("march24");
    this.setState({ issuesGroupCategorySelect: value }, () => {
      firstItem = workflowStates[0];
      if (name === "issuesGroupCategorySelect") {
        firstItem = workflowStates[0];
        //
        if (value === "STATE" || value === "CENTRAL") {
          firstItem = workflowStates.filter(val => val.type.includes(value));
          firstItem = firstItem[0];
        }
        //
        this.fetchIssuesBy({
          groupCategory: value,
          status: firstItem.category,
          march24: checkedValue
        });
        params = {
          issuesStatusSelect: firstItem.category,
          issuesGroupCategorySelect: value,
          issuesStatusSelectText: firstItem.displayName
        };
        let issuesCategoryName =
          value === "CENTRAL" ? "Ministry/State" : "District/Department";
      }
    });
  };
  onSelectChange = e => {
    try {
      const name = e.target.name,
        value = e.target.value;
      const selectedText = e.target.options[e.target.selectedIndex].text;
      const checkedValue = getLocalstorage("march24");
      const { workflowStates } = this.state;
      let firstItem = null;
      let params = {};
      this.setState(
        prevState => {
          if (name === "issuesGroupCategorySelect") {
            firstItem = workflowStates[0];
            //
            if (value === "STATE" || value === "CENTER") {
              firstItem = workflowStates.filter(val =>
                val.type.includes(value)
              );
              firstItem = firstItem[0];
            }
            //
            this.fetchIssuesBy({
              groupCategory: value,
              status: firstItem.category,
              march24: checkedValue
            });
            params = {
              issuesStatusSelect: firstItem.category,
              issuesGroupCategorySelect: value,
              issuesStatusSelectText: firstItem.displayName
            };
            let issuesCategoryName =
              value === "CENTRAL" ? "Ministry/State" : "District/Department";
            return {
              [name]: value,
              [`${name}Text`]: selectedText,
              ...params,
              issuesGroupCategoryName: issuesCategoryName
            };
          }

          return {
            [name]: value,
            [`${name}Text`]: selectedText,
            ...params
            // sponsorGroupCategoryName: sponsorCategoryName,
            //  issuesGroupCategoryName: issuesCategoryName,
          };
        },
        () => {
          if (
            name === "projectStatusSelect" ||
            name === "projectGroupCategorySelect"
          ) {
            this.fetchProjectsBy();
            let sponsorCategoryName;
            if (name === "projectGroupCategorySelect") {
              sponsorCategoryName =
                value === "CENTRAL" ? "Ministry Name" : "Department";

              this.setState({
                sponsorGroupCategoryName: sponsorCategoryName
              });
            }
          } else if (
            name === "projectLocationStatusSelect" ||
            name === "projectLocationGroupCategorySelect"
          ) {
            this.fetchProjectsByLocation();
            if (name === "projectLocationGroupCategorySelect") {
              let locationCategoryName =
                value === "CENTRAL" ? "State" : "District";

              this.setState({
                locationGroupCategoryName: locationCategoryName
              });
            }
          } else if (
            name === "pragatiProjectSelectBy" ||
            name === "prgatiProjectStatusSelect"
          ) {
            this.fetchGetPragatiProject(this.state.prgatiProjectStatusSelect);
            if (name === "pragatiProjectSelectBy") {
              let paragtiCategoryName =
                value === "CENTRAL" ? "Ministry" : "Department";

              this.setState({
                pragatiGroupCategoryName: paragtiCategoryName
              });
            }
          } else if (name === "issuesByCategorySelectBy") {
            this.fetchIssuesByCategory();
          } else if (name === "delayedProjectModeSelect") {
            this.fetchDelayedProjects();
          } else if (name === "costOverrunProjectModeSelect") {
            this.fetchCostOverrunProjects();
          }
        }
      );
    } catch (error) {}
  };

  costOverrunProjectModeSelect = e => {
    this.setState({ costOverrunProjectModeSelect: e.target.value });
    const march24 = getLocalstorage("march24");
    const costOverrunProjectModeSelect = e.target.value;
    let data = { costOverrunProjectModeSelect, march24 };
    if (e.target.value == "All") {
      this.props.getProjectsCostOverRunList(undefined, {
        costOverrunProjectModeSelect: "",
        march24: false
      });
    } else {
      this.props.getProjectsCostOverRunList(undefined, data);
    }
  };
  delayedProject = e => {
    this.setState({ delayedProjectModeSelect: e.target.value });
    const march24 = getLocalstorage("march24");
    const delayedProjectModeSelect = e.target.value;
    let data = { delayedProjectModeSelect, march24 };
    if (e.target.value == "All") {
      this.props.getDelayedProjectsList(undefined, {
        delayedProjectModeSelect: "",
        march24: false
      });
    } else {
      this.props.getDelayedProjectsList(undefined, data);
    }
  };

  // pendingTaskByZoneSelect = (value, name) => {
  //   const user = getLocalstorage('user');

  //   const falseD = false;
  //   const centralDa = [
  //     'STATE_PMG',
  //     'STATE',
  //     'DISTRICT',
  //     'STATE_DEPARTMENT',
  //   ].includes(get(user, 'groupCategory'))
  //     ? this.state.stateAndCentralProjectSelectedBy
  //     : '';

  //   this.setState({ pendingTaskZoneSelect: value }, () => {
  //     this.props.getDashboardPendingTasksAction(undefined, {
  //       falseD,
  //       centralDa,
  //       value,
  //     });
  //   });
  // };

  pendingTaskByZone = e => {
    const zoneId = e.target.value;
    console.log("zoneId", e.target.value, zoneId);
    this.setState({ pendingTaskZoneSelect: zoneId });
    const user = getLocalstorage("user");

    const falseD = false;
    const centralDa = [
      "STATE_PMG",
      "STATE",
      "DISTRICT",
      "STATE_DEPARTMENT"
    ].includes(get(user, "groupCategory"))
      ? this.state.stateAndCentralProjectSelectedBy
      : "";
    this.props.getDashboardPendingTasksAction(undefined, {
      falseD,
      centralDa,
      zoneId
    });
    // this.setState({ pendingTaskZoneSelect: zoneId }, () => {
    //   this.props.getDashboardPendingTasksAction(undefined, {
    //     falseD,
    //     centralDa,
    //     zoneId,
    //   });
    // });
  };
  renderPendingTaskZoneDropdown = () => {
    const {
      panelKey,
      pendingTaskZoneSelect,
      zoneOptions,
      activeTab
    } = this.state;
    const user = getLocalstorage("user");
    const isVisible = user.groupCategory === "PMG" && activeTab !== "comments";
    return (
      <div
        className="dashboard-new-dropdown pending-task-zone-dropdown"
        onClick={e => e.stopPropagation()}
        style={{ visibility: isVisible ? "visible" : "hidden" }}
      >
        <Dropdown
          key={panelKey}
          options={zoneOptions}
          optionLabel="label"
          onHide={this.handleHide}
          value={pendingTaskZoneSelect}
          onChange={e => this.pendingTaskByZone(e)}
          placeholder="Select Zone"
          name="pendingTaskZoneSelect"
          appendTo="self"
          // appendTo={document.body}
        />
      </div>
    );
  };

  onDateChange = value => {
    this.setState({ meetingDate: value }, () => {
      this.fetchMeetingsData();
    });
  };

  fetchProjectsBy = async () => {
    const { projectStatusSelect, projectGroupCategorySelect } = this.state;
    const checkedValue = getLocalstorage("march24");
    this.props.getProjectsBy(undefined, {
      groupCategory: projectGroupCategorySelect,
      status: projectStatusSelect,
      march24: checkedValue
    });
  };

  projectStatusSelect = async e => {
    const { projectGroupCategorySelect } = this.state;
    this.setState({
      projectStatusSelect:
        e.target.value.displayName == "All" ? "" : e.target.value
    });
    const projectStatusSelect = e.target.value;
    const checkedValue = getLocalstorage("march24");
    if (e.target.value.displayName == "All") {
      this.props.getProjectsBy(undefined, {
        groupCategory: projectGroupCategorySelect,
        status: "",
        march24: checkedValue
      });
    } else {
      this.props.getProjectsBy(undefined, {
        groupCategory: projectGroupCategorySelect,
        status: projectStatusSelect,
        march24: checkedValue
      });
    }
  };
  projectLocationStatusSelect = async e => {
    const { projectLocationGroupCategorySelect } = this.state;
    const projectLocationStatusSelect = e.target.value;
    const checkedValue = getLocalstorage("march24");
    if (e.target.value.displayName == "All") {
      this.setState({ projectLocationStatusSelect: "All" });
      this.props.getProjectsByLocation(undefined, {
        groupCategory: projectLocationGroupCategorySelect,
        status: "",
        march24: checkedValue
      });
    } else {
      this.setState({ projectLocationStatusSelect: e.target.value });
      this.props.getProjectsByLocation(undefined, {
        groupCategory: projectLocationGroupCategorySelect,
        status: projectLocationStatusSelect,
        march24: checkedValue
      });
    }
  };
  fetchIssuesByCategory = async () => {
    const { issuesByCategorySelectBy } = this.state;
    const checkedValue = getLocalstorage("march24");
    this.props.getIssuesByCategory(undefined, {
      groupCategory: issuesByCategorySelectBy,
      march24: checkedValue
    });
  };

  fetchProjectsByLocation = async () => {
    const {
      projectLocationStatusSelect,
      projectLocationGroupCategorySelect
    } = this.state;
    const checkedValue = getLocalstorage("march24");
    this.props.getProjectsByLocation(undefined, {
      groupCategory: projectLocationGroupCategorySelect,
      status: projectLocationStatusSelect,
      march24: checkedValue
    });
  };

  fetchGetPragatiProject = params => {
    this.setState({ prgatiProjectStatusSelect: params }, () => {
      const { pragatiProjectSelectBy, prgatiProjectStatusSelect } = this.state;
      const checkedValue = getLocalstorage("march24");
      this.props.getPragatiProjectList(undefined, {
        groupCategory: pragatiProjectSelectBy,
        status: prgatiProjectStatusSelect,
        march24: checkedValue
      });
    });
  };

  fetchDelayedProjects = params => {
    const march24 = getLocalstorage("march24");
    //  const { delayedProjectModeSelect } = this.state;
    const delayedProjectModeSelect = "";
    let data = { delayedProjectModeSelect, march24 };
    this.props.getDelayedProjectsList(undefined, data);
  };

  fetchIssuesBy = async params => {
    this.props.getPendingIssuesBy(undefined, params);
  };

  handleHide = () => {
    this.setState(prev => ({ panelKey: prev.panelKey + 1 }));
  };

  getFilterArrayValue = ({ createdDate, dates }) => {
    const { getDashboardSummary } = this.props;
    const march24 = getLocalstorage("march24");
    const user = getLocalstorage("user");
    const {
      summaryDataBy,
      recipientFilter,
      stateAndCentralProjectSelectedBy
    } = this.state;
    let type = summaryDataBy ? "RECIPIENT" : "SPONSOR";
    const userGroupCategory =
      user.groupCategory === "DISTRICT" ||
      user.groupCategory === "STATE_DEPARTMENT";
    if (dates === "All") {
      createdDate = null;
    }
    let params = {
      createdDate,
      march24
    };
    if (recipientFilter) {
      params.type = type;
    } else if (userGroupCategory) {
      params.groupCategory = stateAndCentralProjectSelectedBy;
    }
    this.setState(
      { filterArray: { createdDate }, displayDateTitle: dates },
      () => {
        getDashboardSummary(undefined, params);
      }
    );
  };

  handlePrint = () => {
    window.print();
  };

  _setGraphState = (summaryData, stateAndCentralProjectSelectedBy) => {
    const { summaryDataBy, updateValues } = this.state;
    const groupCategory = getLocalstorage("groupCategory");
    const summaryType = getLocalstorage("summaryType");
    const checkedValue = getLocalstorage("march24");
    const user = getLocalstorage("user");

    if (Object.keys(summaryData) && Object.keys(summaryData).length) {
      let extractGraph = {};
      for (let key in summaryData) {
        if (summaryData.hasOwnProperty(key)) {
          let value = summaryData[key];
          let { total, open, resolved, noIssues } = value;

          const path =
            Title[key] === "Issue(s)  Monitored"
              ? PATHS.ISSUE_LIST
              : PATHS.PROJECT_LIST;
          const projectSection = REDIRECTION_DASHBOARD_URLS(
            "summary",
            checkedValue,
            groupCategory,
            summaryType,
            user,
            stateAndCentralProjectSelectedBy
          );
          const issueSection = REDIRECTION_DASHBOARD_URLS(
            "summary_issue",
            checkedValue,
            groupCategory,
            summaryType,
            user,
            stateAndCentralProjectSelectedBy
          );

          let resolvedTooltipClass =
            Title[key] === "Project(s) Monitored"
              ? "small-tooltip"
              : Title[key] === "Pragati Project(s)" ||
                Title[key] === "Issue(s)  Monitored"
              ? "large-tooltip"
              : "";

          let openTooltipClass =
            Title[key] === "Project(s) Monitored"
              ? "small-tooltip"
              : Title[key] === "Pragati Project(s)"
              ? "large-tooltip"
              : Title[key] === "Issue(s)  Monitored"
              ? " my-tooltip-burification"
              : "";
          let noIssuesTooltipClass =
            Title[key] === "Project(s) Monitored"
              ? "small-tooltip"
              : Title[key] === "Pragati Project(s)"
              ? "large-tooltip"
              : Title[key] === "Issue(s)  Monitored"
              ? " my-tooltip-burification"
              : "";

          let _open =
            Title[key] === "Issue(s)  Monitored"
              ? issueSection.verified
              : projectSection.open;
          let _resolved =
            Title[key] === "Issue(s)  Monitored"
              ? issueSection.resolved
              : projectSection.resolved;
          let _noIssues = projectSection.noIssues;

          if (Title[key] === "Pragati Project(s)") {
            let path = REDIRECTION_DASHBOARD_URLS(
              "summary_pragati",
              checkedValue,
              groupCategory,
              summaryType,
              user
            );
            _open = path.open;
            _resolved = path.resolved;
            _noIssues = path.noIssues;
          }
          extractGraph[key] = {
            titleText: Title[key],
            titleValue: total || 0,
            leftText: (
              <Link
                onClick={e => e.stopPropagation()}
                to={{
                  pathname: path,
                  isDashBoard: true,
                  summaryDataBy:
                    summaryDataBy &&
                    (groupCategory === "STATE" ||
                      groupCategory === "STATE_PMG" ||
                      groupCategory === "DISTRICT" ||
                      groupCategory === "STATE_DEPARTMENT"),
                  state: {
                    ..._open,
                    // projectFlags: checkedValue
                    //   ? [{ displayName: "MARCH 24", key: "MARCH 24" }]
                    //   : null,
                    ...{
                      // groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
                      //   groupCategory,
                      //   getLocalstorage("summaryType"),
                      //   stateAndCentralProjectSelectedBy
                      // ),
                      groupCategory: stateAndCentralProjectSelectedBy
                    }
                  }
                }}
                className="dashboard-link-tags"
              >
                Open
              </Link>
            ),
            leftValue: (
              <Link
                onClick={e => e.stopPropagation()}
                to={{
                  pathname: path,
                  isDashBoard: true,
                  summaryDataBy:
                    summaryDataBy &&
                    (groupCategory === "STATE" ||
                      groupCategory === "STATE_PMG" ||
                      groupCategory === "DISTRICT" ||
                      groupCategory === "STATE_DEPARTMENT"),
                  state: {
                    ..._open,
                    ...{
                      // groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
                      //   groupCategory,
                      //   getLocalstorage("summaryType"),
                      //   stateAndCentralProjectSelectedBy
                      // ),
                      groupCategory: stateAndCentralProjectSelectedBy
                    }
                  }
                }}
                className="dashboard-link-tags dashboard-link-left"
              >
                {Title[key] === "Project(s) Value" ? (
                  <CountUp
                    start={updateValues}
                    end={open}
                    delay={0}
                    formattingFn={n =>
                      formatNumberOnDashBoard(
                        Number(n.toFixed(1)),
                        true,
                        true,
                        "."
                      )
                    }
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <React.Fragment>
                        <OverlayTrigger
                          overlay={
                            <Tooltip className="my-tooltip-2">
                              {open &&
                                formatNumberOnDashBoard(
                                  parseInt(open),
                                  false
                                )}{" "}
                              Cr.
                            </Tooltip>
                          }
                        >
                          <div>
                            <span ref={countUpRef} />
                          </div>
                        </OverlayTrigger>
                      </React.Fragment>
                    )}
                  </CountUp>
                ) : (
                  <CountUp
                    start={updateValues}
                    end={get(open, "count", 0)}
                    delay={0}
                    formattingFn={n => formatNumber(Number(n.toFixed(1)))}
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <React.Fragment>
                        <OverlayTrigger
                          overlay={
                            groupCategory === "PMG" ||
                            Title[key] === "Issue(s)  Monitored" ? (
                              <Tooltip className={`${openTooltipClass}`}>
                                <table className="dashboard-burification">
                                  {get(open, "bifurcation")
                                    ? Object.entries(get(open, "bifurcation"))
                                        .filter(value => {
                                          return value[1];
                                        })
                                        .map(value => {
                                          return (
                                            <tr>
                                              <td>{value[0]}</td>
                                              {value[0] === "Project Cost" ? (
                                                <td> &#x20B9; {value[1]}</td>
                                              ) : (
                                                <td>{value[1]}</td>
                                              )}
                                            </tr>
                                          );
                                        })
                                    : null}
                                </table>
                              </Tooltip>
                            ) : (
                              <Tooltip id="opacity-0" />
                            )
                          }
                        >
                          <div>
                            <span ref={countUpRef} />
                          </div>
                        </OverlayTrigger>
                      </React.Fragment>
                    )}
                  </CountUp>
                )}
              </Link>
            ),
            centerText: (
              <Link
                onClick={e => e.stopPropagation()}
                to={{
                  pathname: path,
                  isDashBoard: true,
                  summaryDataBy:
                    summaryDataBy &&
                    (groupCategory === "STATE" ||
                      groupCategory === "STATE_PMG" ||
                      groupCategory === "DISTRICT" ||
                      groupCategory === "STATE_DEPARTMENT"),
                  state: {
                    ..._resolved,
                    // projectFlags: checkedValue
                    //   ? [{ displayName: "MARCH 24", key: "MARCH 24" }]
                    //   : null,
                    ...{
                      // groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
                      //   groupCategory,
                      //   getLocalstorage("summaryType"),
                      //   stateAndCentralProjectSelectedBy
                      // ),
                      groupCategory: stateAndCentralProjectSelectedBy
                    }
                  }
                }}
                className="dashboard-link-tags"
              >
                Resolved
              </Link>
            ),
            centerValue: (
              <Link
                onClick={e => e.stopPropagation()}
                to={{
                  pathname: path,
                  isDashBoard: true,
                  summaryDataBy:
                    summaryDataBy &&
                    (groupCategory === "STATE" ||
                      groupCategory === "STATE_PMG" ||
                      groupCategory === "DISTRICT" ||
                      groupCategory === "STATE_DEPARTMENT"),
                  state: {
                    ..._resolved,
                    ...{
                      // groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
                      //   groupCategory,
                      //   getLocalstorage("summaryType"),
                      //   stateAndCentralProjectSelectedBy
                      // ),
                      groupCategory: stateAndCentralProjectSelectedBy
                    }
                  }
                }}
                className="dashboard-link-tags dashboard-link-right"
              >
                {Title[key] === "Project(s) Value" ? (
                  <CountUp
                    start={updateValues}
                    end={resolved}
                    delay={0}
                    formattingFn={n =>
                      formatNumberOnDashBoard(
                        Number(n.toFixed(1)),
                        true,
                        true,
                        "."
                      )
                    }
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <React.Fragment>
                        <OverlayTrigger
                          overlay={
                            <Tooltip className="my-tooltip-3">
                              {resolved &&
                                formatNumberOnDashBoard(
                                  parseInt(resolved),
                                  false
                                )}{" "}
                              Cr.
                            </Tooltip>
                          }
                        >
                          <div>
                            <span ref={countUpRef} />
                          </div>
                        </OverlayTrigger>
                      </React.Fragment>
                    )}
                  </CountUp>
                ) : (
                  <CountUp
                    start={updateValues}
                    end={get(resolved, "count", 0)}
                    delay={0}
                    useEasing={true}
                    formattingFn={n => formatNumber(Number(n.toFixed(1)))}
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <React.Fragment>
                        <OverlayTrigger
                          overlay={
                            groupCategory === "PMG" ? (
                              <Tooltip className={`${resolvedTooltipClass}`}>
                                <table className="dashboard-burification">
                                  {get(resolved, "bifurcation")
                                    ? Object.entries(
                                        get(resolved, "bifurcation")
                                      )
                                        .filter(value => {
                                          return value[1];
                                        })
                                        .map(value => {
                                          return (
                                            <tr>
                                              <td>{value[0]}</td>
                                              {value[0] === "Project Cost" ? (
                                                <td> &#x20B9; {value[1]}</td>
                                              ) : (
                                                <td>{value[1]}</td>
                                              )}
                                            </tr>
                                          );
                                        })
                                    : null}
                                </table>
                              </Tooltip>
                            ) : (
                              <Tooltip id="opacity-0" />
                            )
                          }
                        >
                          <div>
                            <span ref={countUpRef} />
                          </div>
                        </OverlayTrigger>
                      </React.Fragment>
                    )}
                  </CountUp>
                )}
              </Link>
            ),
            rightText: Title[key] !== "Issue(s)  Monitored" && (
              <Link
                onClick={e => e.stopPropagation()}
                to={{
                  pathname: path,
                  isDashBoard: true,
                  summaryDataBy:
                    summaryDataBy &&
                    (groupCategory === "STATE" ||
                      groupCategory === "STATE_PMG" ||
                      groupCategory === "DISTRICT" ||
                      groupCategory === "STATE_DEPARTMENT"),
                  state: {
                    ..._noIssues,
                    // projectFlags: checkedValue
                    //   ? [{ displayName: "MARCH 24", key: "MARCH 24" }]
                    //   : null,
                    ...{
                      // groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
                      //   groupCategory,
                      //   getLocalstorage("summaryType"),
                      //   stateAndCentralProjectSelectedBy
                      // ),
                      groupCategory: stateAndCentralProjectSelectedBy
                    }
                  }
                }}
                className="dashboard-link-tags"
              >
                No Issues
              </Link>
            ),
            rightValue: Title[key] !== "Issue(s)  Monitored" && (
              <Link
                onClick={e => e.stopPropagation()}
                to={{
                  pathname: path,
                  isDashBoard: true,
                  summaryDataBy:
                    summaryDataBy &&
                    (groupCategory === "STATE" ||
                      groupCategory === "STATE_PMG" ||
                      groupCategory === "DISTRICT" ||
                      groupCategory === "STATE_DEPARTMENT"),
                  state: {
                    ..._noIssues,
                    ...{
                      // groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
                      //   groupCategory,
                      //   getLocalstorage("summaryType"),
                      //   stateAndCentralProjectSelectedBy
                      // ),
                      groupCategory: stateAndCentralProjectSelectedBy
                    }
                  }
                }}
                className="dashboard-link-tags dashboard-link-right"
              >
                {Title[key] === "Project(s) Value" ? (
                  <CountUp
                    start={updateValues}
                    end={noIssues}
                    delay={0}
                    formattingFn={n =>
                      formatNumberOnDashBoard(
                        Number(n.toFixed(1)),
                        true,
                        true,
                        "."
                      )
                    }
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <React.Fragment>
                        <OverlayTrigger
                          overlay={
                            <Tooltip className="my-tooltip-3">
                              {noIssues &&
                                formatNumberOnDashBoard(
                                  parseInt(noIssues),
                                  false
                                )}{" "}
                              Cr.
                            </Tooltip>
                          }
                        >
                          <div>
                            <span ref={countUpRef} />
                          </div>
                        </OverlayTrigger>
                      </React.Fragment>
                    )}
                  </CountUp>
                ) : (
                  <CountUp
                    start={updateValues}
                    end={get(noIssues, "project", 0)}
                    delay={0}
                    useEasing={true}
                    formattingFn={n => formatNumber(Number(n.toFixed(1)))}
                    duration={2.75}
                  >
                    {({ countUpRef }) => (
                      <React.Fragment>
                        <OverlayTrigger
                          overlay={
                            groupCategory === "PMG" ? (
                              <Tooltip className={`${noIssuesTooltipClass}`}>
                                <table className="dashboard-burification">
                                  {get(noIssues, "project") ? (
                                    <>
                                      <tr>
                                        <td>Projects</td>
                                        <td>{get(noIssues, "project")}</td>
                                      </tr>
                                      {get(noIssues, "projectCost") && (
                                        <tr>
                                          <td>Project Value</td>
                                          <td>
                                            {formatNumberOnDashBoard(
                                              parseInt(
                                                get(noIssues, "projectCost")
                                              ),
                                              false
                                            )}{" "}
                                            Cr.
                                          </td>
                                        </tr>
                                      )}
                                    </>
                                  ) : null}
                                </table>
                              </Tooltip>
                            ) : (
                              <Tooltip id="opacity-0" />
                            )
                          }
                        >
                          <div>
                            <span ref={countUpRef} />
                          </div>
                        </OverlayTrigger>
                      </React.Fragment>
                    )}
                  </CountUp>
                )}
              </Link>
            )
          };
        }
      }

      return extractGraph;
    }

    return {};
  };

  //Sort Data
  sortData = (key, nullKey) => {
    this.setState(prevState => {
      const order = prevState[key] === "asc" ? "dsc" : "asc";
      return {
        [key]: order,
        [nullKey]: null
      };
    });
  };

  sortTimelineTableData = (key, headingsForDelayedProject) => {
    let filteredVal =
      Array.isArray(headingsForDelayedProject) &&
      headingsForDelayedProject.filter(item => item.key !== key);
    let obj = {};
    filteredVal.map(item => {
      obj[item.key] = null;
    });
    this.setState(prevState => {
      const order = prevState[key] === "dsc" ? "asc" : "dsc";
      return {
        [key]: order,
        delayedProjectDataSortkey: key,
        ...obj
      };
    });
  };

  sortCostOverrunTimelineTableData = (key, headingsForCostOverrunProject) => {
    let filteredVal =
      Array.isArray(headingsForCostOverrunProject) &&
      headingsForCostOverrunProject.filter(item => item.key !== key);
    let obj = {};
    filteredVal.map(item => {
      obj[item.key] = null;
    });
    this.setState(prevState => {
      const order = prevState[key] === "dsc" ? "asc" : "dsc";
      return {
        [key]: order,
        costOverrunProjectDataSortkey: key,
        ...obj
      };
    });
  };

  sortIssueRecipientData = (key, nullKeyArr) => {
    let obj = {};
    nullKeyArr.map(item => (obj[item] = null));
    this.setState(prevState => {
      const order = prevState[key] === "dsc" ? "asc" : "dsc";
      return {
        [key]: order,
        sortRecipientKey: key,
        ...obj
      };
    });
  };

  taskStatusResult = num => {
    this.setState(prevState => ({
      taskStatus: prevState.taskStatus === num ? false : num
    }));
  };
  onDownloadDashboardSummary = () => {
    const { getDownloadDashboardSummaryAction } = this.props;
    const checkedValue = getLocalstorage("march24");
    const user = getLocalstorage("user");
    const userGroupCategory =
      user.groupCategory === "DISTRICT" ||
      user.groupCategory === "STATE_DEPARTMENT" ||
      user.groupCategory === "STATE" ||
      user.groupCategory === "STATE_PMG";
    // const isStateAndStatePmgUser =
    //   user.groupCategory === "STATE" || user.groupCategory === "STATE_PMG";
    const { filterArray, stateAndCentralProjectSelectedBy } = this.state;
    let params = {
      ...filterArray,
      march24: checkedValue
    };
    // if (isStateAndStatePmgUser) {
    //   params.dashboardSummaryType = getLocalstorage("summaryType");
    // }
    if (userGroupCategory) {
      params.groupCategory = stateAndCentralProjectSelectedBy;
    }
    getDownloadDashboardSummaryAction(undefined, params);
  };

  onClearDownloadDashboardSummary = () => {
    const { clearDashboardSummaryAction } = this.props;
    clearDashboardSummaryAction();
  };

  onProjectAwardedByChange = e => {
    const { getDashboardSummary } = this.props;
    const march24 = getLocalstorage("march24");
    const summaryDataBy = e.target.checked;
    const groupCategory = getLocalstorage("groupCategory");
    this.setState(
      {
        summaryDataBy
      },
      () => {
        setLocalstorage("summaryType", summaryDataBy ? "RECIPIENT" : "SPONSOR");
        getDashboardSummary(undefined, {
          ...this.state.filterArray,
          type: summaryDataBy ? "RECIPIENT" : "SPONSOR",
          march24
        });
      }
    );
  };

  onProjectCategoryByChange = e => {
    const checkedValue = getLocalstorage("march24");
    this.setState({
      stateAndCentralFilterChecked: e.target.checked,
      stateAndCentralProjectSelectedBy: e.target.name
    });
    this.props.getDashboardSummary(undefined, {
      ...this.state.filterArray,
      groupCategory: e.target.name,
      march24: checkedValue
    });
    const falseD = false;
    const centralDa = e.target.name;
    //const data = { falseD, centralDa };
    const zoneId = this.state.pendingTaskZoneSelect;
    const data = { falseD, centralDa, zoneId };
    this.props.getDashboardPendingTasksAction(undefined, data);
  };

  getWorkflowStates = async () => {
    try {
      const resp = await getWorkflowStatesAction();
      const { data } = resp;
      let list = [];
      if (data && data.status) {
        const status = [
          "HOLD",
          "RESOLVED",
          "REJECT",
          "UNDER_PROCESS",
          "UNDER_DECISION"
        ];
        list = [
          ...data.data.central.filter(val => {
            if (
              !status.includes(val.category) &&
              val.category !== "UNDER_CENTRAL_PMG"
            ) {
              val.type = ["CENTRAL"];
              val.key = val.id.toString();
              val.value = val.category;
              val.displayName = val.name;
              return val;
            }
          }),
          ...data.data.state.filter(val => {
            if (!status.includes(val.category)) {
              val.type = ["STATE"];
              val.key = val.id.toString();
              val.value = val.category;
              val.displayName = val.name;
              return val;
            }
          })
        ];
        // only for these three condition
        const remaningFilter = data.data.state.filter(val => {
          if (status.includes(val.category)) {
            val.type = ["STATE", "CENTRAL"];
            val.key = val.id.toString();
            val.value = val.category;
            val.displayName = val.name;
            return val;
          }
        });
        list = [...list, ...remaningFilter];
      }
      this.setState({
        workflowStates: list
      });
    } catch (error) {}
  };

  onIssuesStatusSelect = e => {
    const { workflowStates, issuesGroupCategorySelect } = this.state;
    const { value } = e.target;
    const currentItem = workflowStates.find(val => val.category === value);
    const checkedValue = getLocalstorage("march24");
    this.fetchIssuesBy({
      groupCategory: issuesGroupCategorySelect,
      status: currentItem.category,
      march24: checkedValue
    });
    this.setState({
      issuesStatusSelectText: currentItem.displayName,
      issuesStatusSelect: value
    });
  };

  //Get meeting table Data
  getMeetingTableData = async () => {
    const checkedValue = getLocalstorage("march24");
    this.setState({
      meetingTableStatus: true
    });
    try {
      const MeetingTableData = await getMeetingTableAction(
        undefined,
        checkedValue
      );
      const getModifiedData =
        !!MeetingTableData &&
        isValidArray(MeetingTableData.data) &&
        this.modifyMeetingData(MeetingTableData.data);
      this.setState({
        meetingTableData: getModifiedData,
        meetingTableStatus: false
      });
    } catch (error) {
      this.setState({
        meetingTableStatus: false
      });
    }
  };

  //Modify the Meeting Table Data
  modifyMeetingData = meetingsData => {
    const groupedData = groupBy(meetingsData, "meetingBy");
    const groupMonths = groupBy(meetingsData, "month");
    return { groupedData, groupMonths };
  };

  //Uploading Meeting Table CSV File
  uploadMeetingCSV = async formData => {
    let data = {};
    this.setState({
      uploadMeetingTableStatus: true
    });
    try {
      const meetingType = "UPCOMING_3_MONTHS";
      data = await uploadMeetingTableAction(undefined, meetingType, formData);
      this.setState({
        uploadMeetingTableStatus: false
      });
    } catch (error) {
      this.setState({
        uploadMeetingTableStatus: false
      });
    }
    return data;
  };

  toggleChange = () => {
    this.setState({
      isChecked: !this.state.isChecked
    });

    setLocalstorage("march24", !this.state.isChecked);
    this.fetchApi();
  };
  onMarch24ReportDownaloadStart = () => {
    const { downloadMarch24ReportExcelAction } = this.props;
    downloadMarch24ReportExcelAction();
  };
  onClearMarch24ReportDowload = () => {
    const { clearDownloadMarch24ReportExcelAction } = this.props;
    clearDownloadMarch24ReportExcelAction();
  };

  handleZoomChange = zoom => {
    this.setState({ zoomPercentage: zoom });
  };

  width = zoomPercentage => {
    if (zoomPercentage == 110) {
      return "87%";
    } else if (zoomPercentage == 100) {
      return "89%";
    } else if (zoomPercentage == 90 || zoomPercentage == 80) {
      return "93%";
    }
  };

  chairedWidth = zoomPercentage => {
    if (zoomPercentage == 110) {
      return "8.3rem";
    } else if (zoomPercentage == 100) {
      return "9.8rem";
    } else if (zoomPercentage == 90) {
      return "10.5rem";
    } else return "11rem";
  };

  gridGap = zoomPercentage => {
    if (zoomPercentage == 110) {
      return "20px";
    }
  };

  spacebreak = zoomPercentage => {
    if (zoomPercentage == 110) {
      return "break-spaces";
    }
  };

  maxWidth = zoomPercentage => {
    if (zoomPercentage == 110) {
      return "85%";
    } else if (zoomPercentage == 100) {
      return "90%";
    }
  };

  render() {
    const {
      onDownloadDashboardSummary,
      onClearDownloadDashboardSummary,
      onMarch24ReportDownaloadStart,
      onClearMarch24ReportDowload
    } = this;

    // Real Data
    const {
      summaryData,
      issuesByCategoryData,
      issuesByCategoryGanttChartData,
      projectsByData,
      projectsByLocationData,
      issuesByData,
      kanbanData,
      issueList,
      meetingsData,
      notificationData,
      notificationStatus,
      permission,
      meetingsAPIStatus,
      issuesByDataStatus,
      projectsByDataStatus,
      projectsByLocationDataStatus,
      issuesByCategoryDataStatus,
      issuesByCategoryGanttChartDataStatus,
      projectsByPragatiData,
      projectsByPragatiDataStatus,
      dashboardSummaryReducer,
      upcomingMeetingStatus,
      upcomingMeeting,
      childIssueStatus,
      childIssueData,
      pendingTaskLoading,
      pendingTask,
      showTeamSectionData,
      downloadWeeklyReportForStatePmg,
      statePmgReportReducer,
      clearWeeklyReportForStatePmgAction,
      isDesktopView,
      delayedProjectStatus,
      delayedProjectData,
      costOverrunProjectStatus,
      costOverrunProjectData,
      getPmgMeetingData,
      getPmgMeetingStatus,
      getProjectStagesForGraphsStatus,
      getProjectStagesForGraphsData,
      history,
      summaryDataStatus,
      march24ReportReducer
    } = this.props;
    const {
      projectStatusSelect,
      projectLocationStatusSelect,
      projectLocationGroupCategorySelect,
      projectGroupCategorySelect,
      delayedProjectModeSelect,
      issuesStatusSelect,
      issuesStatusSelectText,
      issuesGroupCategorySelect,
      sortProjectOrder,
      sortProjectLocationOrder,
      sortProjectLocationCost,
      sortProjectCost,
      sortTotalIssue,
      sortIssueStatus,
      sortProjectScheme,
      sortProjectSchemeValue,
      sortIssueCategoryCount,
      filterArray,
      resolveToggle,
      showLoader,
      taskStatus,
      recipientFilter,
      stateAndCentralFilter,
      pragatiProjectSelectBy,
      issuesByCategorySelectBy,
      prgatiProjectStatusSelect,
      summaryDataBy,
      workflowStates,
      displayDateTitle,
      delayedProjectDataSortkey,
      costOverrunProjectModeSelect,
      costOverrunProjectDataSortkey,
      sortRecipientKey,
      meetingTableData,
      meetingTableStatus,
      uploadMeetingTableStatus,
      isChecked,
      stateAndCentralFilterChecked,
      stateAndCentralProjectSelectedBy,
      zoomPercentage,
      panelKey,
      isOpen,
      selected,
      activeTab,
      issuesData,
      pendingComments,
      pendingCommentsStatus,
      hoverItem,
      pendingTaskZoneSelect
    } = this.state;
    const user = getLocalstorage("user");
    const checkedValue = getLocalstorage("march24");
    const userGroupCategory =
      user.groupCategory === "PMG" || user.groupCategory === "CENTRAL";
    const isStateAndDistrictUser =
      user.groupCategory === "DISTRICT" ||
      user.groupCategory === "STATE_DEPARTMENT";
    const pendingCommentsVisible =
      user.groupCategory === "CENTRAL_DEPARTMENT" ||
      user.groupCategory === "CENTRAL";
    const ppUser = user.groupCategory === "PP";
    const isVisible = user.groupCategory === "PMG" && activeTab !== "comments";
    const {
      pragatiReview: PragatiReview,
      issueCount: IssueCount,
      projectCount: ProjectCount,
      projectCost: ProjectCost
    } = this._setGraphState(summaryData, stateAndCentralProjectSelectedBy);
    const MinistryIcon =
      "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/icon_ministry.png";
    let isEmptyProject = true;
    let groupCategory = getLocalstorage("groupCategory");
    setLocalstorage(
      "stateAndCentralProjectSelectedBy",
      stateAndCentralProjectSelectedBy
    );
    const templateProjectByLocation =
      isValidArray(projectsByLocationData) &&
      sortBy(
        projectsByLocationData,
        sortProjectLocationOrder ? "totalProjectCount" : "projectCost",
        sortProjectLocationCost || sortProjectLocationOrder
      ).map((project, idx) => {
        const count = get(project, "totalProjectCount") !== 0;
        isEmptyProject && count > 0 && (isEmptyProject = false);
        return count ? (
          <tr key={`key-${idx}`}>
            <td>
              {projectLocationGroupCategorySelect === "STATE" ? (
                <Link
                  className="dashboard-link-tags"
                  to={{
                    pathname: PATHS.PROJECT_LIST,
                    isDashBoard: true,
                    summaryDataBy:
                      projectLocationGroupCategorySelect === "STATE",
                    state: {
                      districtProjectLocation: [
                        {
                          key: project.locationId.toString(),
                          displayName: project.locationName
                        }
                      ],
                      groupCategory: "STATE",
                      projectFlags: checkedValue
                        ? [
                            {
                              displayName: "MARCH 24",
                              key: "MARCH 24"
                            }
                          ]
                        : null,
                      projectStage: projectLocationStatusSelect
                        ? filtersDropDown.filter(
                            val => val.key === projectLocationStatusSelect
                          )
                        : []
                    }
                  }}
                >
                  {get(project, "locationName", "NA")}
                </Link>
              ) : (
                <Link
                  className="dashboard-link-tags"
                  to={{
                    pathname: PATHS.PROJECT_LIST,
                    isDashBoard: true,
                    summaryDataBy:
                      projectLocationGroupCategorySelect === "STATE",
                    state: {
                      projectLocation: [
                        {
                          key: project.locationId.toString(),
                          displayName: project.locationName
                        }
                      ],
                      groupCategory: "CENTRAL",
                      projectFlags: checkedValue
                        ? [
                            {
                              displayName: "MARCH 24",
                              key: "MARCH 24"
                            }
                          ]
                        : null,
                      projectStage: projectLocationStatusSelect
                        ? filtersDropDown.filter(
                            val => val.key === projectLocationStatusSelect
                          )
                        : []
                    }
                  }}
                >
                  {get(project, "locationName", "NA")}
                </Link>
              )}
            </td>
            <td>{get(project, "totalProjectCount", 0)}</td>
            <td>
              &#8377;{" "}
              {get(project, "projectCost")
                ? parseInt(get(project, "projectCost", 0))
                : null}{" "}
              Cr.
            </td>
          </tr>
        ) : null;
      });

    const templateProjectBy =
      isValidArray(projectsByData) &&
      sortBy(
        projectsByData,
        sortProjectOrder ? "projectStatusCount" : "projectCost",
        sortProjectCost || sortProjectOrder
      ).map((project, idx) => {
        const count =
          get(project, "totalProjectCount") !== 0 &&
          get(project, "projectStatusCount") !== 0;
        isEmptyProject && count > 0 && (isEmptyProject = false);
        return count ? (
          <tr key={`key-${idx}`}>
            {/* <td>
              <Image
                src={get(project, "imageUrl", null) || MinistryIcon}
                alt="Road Icon"
              />
            </td> */}
            <td>
              <Link
                className="dashboard-link-tags"
                to={{
                  pathname: PATHS.PROJECT_LIST,
                  isDashBoard: true,
                  summaryDataBy: projectGroupCategorySelect === "STATE",
                  state:
                    projectGroupCategorySelect === "STATE"
                      ? {
                          sponsoringDepartment: [
                            {
                              key: project.groupId.toString(),
                              displayName: project.groupName
                            }
                          ],
                          groupCategory: "STATE",
                          projectStage: projectStatusSelect
                            ? filtersDropDown.filter(
                                val => val.key === projectStatusSelect
                              )
                            : []
                        }
                      : {
                          sponsoringMinistry: [
                            {
                              key: project.groupId.toString(),
                              displayName: project.groupName
                            }
                          ],
                          groupCategory: "CENTRAL",
                          projectFlags: checkedValue
                            ? [
                                {
                                  displayName: "MARCH 24",
                                  key: "MARCH 24"
                                }
                              ]
                            : null,
                          projectStage: projectStatusSelect
                            ? filtersDropDown.filter(
                                val => val.key === projectStatusSelect
                              )
                            : []
                        }
                }}
              >
                {get(project, "groupName", "NA")}
              </Link>
            </td>
            <td>{get(project, "projectStatusCount", 0)}</td>
            <td>
              &#8377;{" "}
              {get(project, "projectCost")
                ? parseInt(get(project, "projectCost", 0))
                : null}{" "}
              Cr.
            </td>
          </tr>
        ) : null;
      });
    let demo = projectStatusSelect
      ? filtersDropDown.filter(val => val.key === projectStatusSelect)
      : [];
    const templateDelayedProject =
      isValidArray(delayedProjectData) &&
      sortBy(
        delayedProjectData,
        delayedProjectDataSortkey,
        this.state[delayedProjectDataSortkey]
      ).map((project, idx) => {
        let delayProjectData = get(project, "projectData", []);
        return (
          <tr key={`key-${idx}`}>
            {/* <td>
              <Image src={MinistryIcon} alt="Icon" />
            </td> */}
            <td>
              <Link
                className="dashboard-link-tags"
                to={{
                  pathname: PATHS.PROJECT_LIST,
                  isDashBoard: true,
                  summaryDataBy: false,
                  state: {
                    sponsoringMinistry: [
                      {
                        key: project.groupId.toString(),
                        displayName: project.groupName
                      }
                    ],
                    groupCategory: "CENTRAL",
                    projectFlags: checkedValue
                      ? [
                          {
                            displayName: "MARCH 24",
                            key: "MARCH 24"
                          }
                        ]
                      : null,
                    projectStage: [
                      {
                        displayName: "VERIFIED",
                        key: "VERIFIED"
                      }
                    ],
                    projectImplementationMode: delayedProjectModeSelect
                      ? [
                          {
                            displayName: delayedProjectModeSelect,
                            key: delayedProjectModeSelect
                          }
                        ]
                      : []
                  }
                }}
              >
                {get(project, "groupName", "NA")}
              </Link>
            </td>
            {delayProjectData &&
              delayProjectData.length &&
              delayProjectData.map((item, index) => {
                return (
                  <td key={index}>
                    {get(item, "projectCount", 0) > 0 ? (
                      <Link
                        className="dashboard-link-tags"
                        to={{
                          pathname: PATHS.PROJECT_LIST,
                          isDashBoard: true,
                          summaryDataBy: false,
                          state: {
                            sponsoringMinistry: [
                              {
                                key: project.groupId.toString(),
                                displayName: project.groupName
                              }
                            ],
                            delayedProject: [
                              { key: item.filter, displayName: item.key }
                            ],
                            groupCategory: "CENTRAL",
                            projectStage: [
                              {
                                displayName: "VERIFIED",
                                key: "VERIFIED"
                              }
                            ],
                            projectImplementationMode: delayedProjectModeSelect
                              ? [
                                  {
                                    displayName: delayedProjectModeSelect,
                                    key: delayedProjectModeSelect
                                  }
                                ]
                              : []
                          }
                        }}
                      >
                        {get(item, "projectCount", 0)}
                      </Link>
                    ) : (
                      get(item, "projectCount", 0)
                    )}{" "}
                    <div>
                      {get(item, "projectCost")
                        ? `(${parseInt(get(item, "projectCost", 0))}Cr.)`
                        : null}
                    </div>
                  </td>
                );
              })}
          </tr>
        );
      });

    const templateCostOverrunProject =
      isValidArray(costOverrunProjectData) &&
      sortBy(
        costOverrunProjectData,
        costOverrunProjectDataSortkey,
        this.state[costOverrunProjectDataSortkey]
      ).map((project, idx) => {
        let costOverrunProjectData = get(project, "projectData", []);
        return (
          <tr key={`key-${idx}`}>
            {/* <td>
              <Image src={MinistryIcon} alt="Icon" />
            </td> */}
            <td>
              <Link
                className="dashboard-link-tags"
                to={{
                  pathname: PATHS.PROJECT_LIST,
                  isDashBoard: true,
                  summaryDataBy: false,
                  state: {
                    sponsoringMinistry: [
                      {
                        key: project.groupId.toString(),
                        displayName: project.groupName
                      }
                    ],
                    groupCategory: "CENTRAL",
                    projectFlags: checkedValue
                      ? [
                          {
                            displayName: "MARCH 24",
                            key: "MARCH 24"
                          }
                        ]
                      : null,
                    projectStage: [
                      {
                        displayName: "VERIFIED",
                        key: "VERIFIED"
                      }
                    ],
                    projectImplementationMode: costOverrunProjectModeSelect
                      ? [
                          {
                            displayName: costOverrunProjectModeSelect,
                            key: costOverrunProjectModeSelect
                          }
                        ]
                      : []
                  }
                }}
              >
                {get(project, "groupName", "NA")}
              </Link>
            </td>
            {costOverrunProjectData &&
              costOverrunProjectData.length &&
              costOverrunProjectData.map((item, index) => {
                return (
                  <td key={index}>
                    {get(item, "projectCount", 0) > 0 ? (
                      <Link
                        className="dashboard-link-tags"
                        to={{
                          pathname: PATHS.PROJECT_LIST,
                          isDashBoard: true,
                          summaryDataBy: false,
                          state: {
                            sponsoringMinistry: [
                              {
                                key: project.groupId.toString(),
                                displayName: project.groupName
                              }
                            ],
                            costOverRun: [
                              { key: item.filter, displayName: item.key }
                            ],
                            groupCategory: "CENTRAL",
                            projectStage: [
                              {
                                displayName: "VERIFIED",
                                key: "VERIFIED"
                              }
                            ],
                            projectImplementationMode: costOverrunProjectModeSelect
                              ? [
                                  {
                                    displayName: costOverrunProjectModeSelect,
                                    key: costOverrunProjectModeSelect
                                  }
                                ]
                              : []
                          }
                        }}
                      >
                        {get(item, "projectCount", 0)}
                      </Link>
                    ) : (
                      get(item, "projectCount", 0)
                    )}{" "}
                    <div>
                      {get(item, "projectCost")
                        ? `(${parseInt(get(item, "projectCost", 0))}Cr.)`
                        : null}
                    </div>
                  </td>
                );
              })}
          </tr>
        );
      });

    const settings = {
      dots: true,
      infinite: true,
      speed: 100,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    };

    let headingsForDelayedProject =
      delayedProjectData &&
      delayedProjectData.length &&
      delayedProjectData[0].projectData;

    let headingsForCostOverrunProject =
      costOverrunProjectData &&
      costOverrunProjectData.length &&
      costOverrunProjectData[0].projectData;

    return (
      <React.Fragment>
        <LoaderPage loading={showLoader || uploadMeetingTableStatus} />
        <ZoomLevelProvider onZoomChange={this.handleZoomChange} />
        <div className="content no-sidebar page-dashboard">
          <div
            className={`container ${get(user, "groupCategory") !== "PMG" &&
              "pp-dashboard"}`}
          >
            <div className={`dashboard-header d-flex justify-content-between`}>
              <div className="">
                {(get(user, "groupCategory") === "STATE" ||
                  get(user, "groupCategory") === "DISTRICT" ||
                  get(user, "groupCategory") === "STATE_PMG" ||
                  get(user, "groupCategory") === "STATE_DEPARTMENT") &&
                (get(user, "groupName")
                  .toLowerCase()
                  .includes("delhi") ||
                  get(user, "groupName").includes("-DL")) ? (
                  <h1 className="page-heading" style={{ color: "#1a2c8b" }}>
                    <span
                      className="page-heading"
                      style={{
                        color: "#1a2c8b",
                        fontSize: "22px",
                        fontFamily: "mpb"
                      }}
                    >
                      DELHI
                    </span>{" "}
                    <span
                      className="page-heading"
                      style={{
                        color: "#e86234",
                        fontSize: "22px",
                        fontFamily: "mpb"
                      }}
                    >
                      CM-PRAGATI
                    </span>
                  </h1>
                ) : (
                  <h1 className="page-heading">My Dashboard</h1>
                )}
              </div>
              <div className="d-flex justify-content-between dashboard-word-document">
                {checkedValue && (
                  <OverlayTrigger
                    show={true}
                    defaultShow={false}
                    placement="top"
                    overlay={
                      <Tooltip
                        id={`tooltip-checking`}
                        className="create_project_tolltip"
                      >
                        March 2024 Projects Compliance Report
                      </Tooltip>
                    }
                  >
                    <div>
                      <DownloadExcelReport
                        isLoading={march24ReportReducer.isLoading}
                        downloadLink={march24ReportReducer.downloadingSrc}
                        onClearDownload={onClearMarch24ReportDowload}
                        onStartDownloading={onMarch24ReportDownaloadStart}
                        iconClassName="doc-icon"
                      />
                    </div>
                  </OverlayTrigger>
                )}
                {/* {userGroupCategory && (
                  <div className="toogle_switch">
                    <Form.Check className="d-flex">
                      <Form.Check.Input
                        type="checkbox"
                        checked={checkedValue}
                      />
                      <Form.Check.Label onClick={() => this.toggleChange()} />
                      <div className="toogle-label ml-2">March’24 Projects</div>
                    </Form.Check>
                  </div>
                )} */}
              </div>

              <DisplayByPermission display={get(permission, "statePMGReport")}>
                <div className="button-group">
                  State PMG Report
                  <DownloadExcelReport
                    isLoading={statePmgReportReducer.isLoading}
                    downloadLink={statePmgReportReducer.downloadingSrc}
                    onClearDownload={() => clearWeeklyReportForStatePmgAction()}
                    onStartDownloading={() => downloadWeeklyReportForStatePmg()}
                    iconClassName="doc-icon"
                  />
                </div>
              </DisplayByPermission>
            </div>

            <div className="dashboard-items">
              {/* index forth Page */}
              {getProjectStagesForGraphsData &&
              getProjectStagesForGraphsData[0].count === 0 &&
              getProjectStagesForGraphsData[1].count === 0 &&
              user.groupCategory === "CENTRAL" ? (
                <></>
              ) : (
                <section className="pdf-container" style={{ paddingTop: 0 }}>
                  <FourthPage
                    displayOnDashboard={true}
                    permission={permission}
                    dashboardClass="dashboard-charts"
                    isDesktopView={isDesktopView}
                    issuesByCategoryData={issuesByCategoryGanttChartData}
                    issuesByCategoryDataStatus={
                      issuesByCategoryGanttChartDataStatus
                    }
                    getPmgMeetingData={getPmgMeetingData}
                    getPmgMeetingStatus={getPmgMeetingStatus}
                    getProjectStagesForGraphsStatus={
                      getProjectStagesForGraphsStatus
                    }
                    getProjectStagesForGraphsData={
                      getProjectStagesForGraphsData
                    }
                    getMeetingTableData={this.getMeetingTableData}
                    uploadMeetingCSV={this.uploadMeetingCSV}
                    meetingTableStatus={meetingTableStatus}
                    meetingTableData={meetingTableData}
                    history={history}
                    checkedValue={checkedValue}
                    user={user}
                  />
                </section>
              )}

              {/* For PMG: hide Meeting Status chart on mobile dashboard. */}
              {isDesktopView || get(user, "groupCategory") === "PMG" ? null : (
                <DisplayByPermission
                  display={get(permission, "readMeetingChairedByStatusReport")}
                >
                  <div className="project-by even">
                    <div
                      className="mobile-heading"
                      onClick={() => this.taskStatusResult(11)}
                    >
                      <h3>Meetings Status</h3>
                    </div>
                    <div
                      className={`pending-tasks-inner popover-wrapper pdf-container dashboard-charts ${
                        taskStatus === 11 ? "link-display" : ""
                      }`}
                    >
                      {" "}
                      {/* popover-visible */}
                      <div className="dashboard-heading-wrapper popover-title">
                        <div
                          className="back-btn"
                          onClick={() => this.taskStatusResult(11)}
                        />
                        <h3>Meetings Status</h3>
                        <div className="download-options">
                          <UploadCSVComponent
                            uploadMeetingCSV={this.uploadMeetingCSV}
                            callApiOnSuccess={this.getMeetingTableData}
                          />
                        </div>
                      </div>
                      <div className="meeting-status-wrapper meeting-status-box">
                        <MeetingTable
                          meetingTableData={meetingTableData}
                          meetingTableStatus={meetingTableStatus}
                        />
                      </div>
                    </div>
                  </div>
                </DisplayByPermission>
              )}

              {/** Dash Board Permission */}
              <div className="summary even">
                <div className="summary-heading-wrapper">
                  <div className="summary-tile-section-left">
                    <h2 className="summary-heading"> Summary </h2>
                    {recipientFilter ? (
                      <ToggleBtn
                        checked={
                          getLocalstorage("summaryType") === "RECIPIENT"
                            ? true
                            : false
                        }
                        checkedTitle="RECIPIENT"
                        uncheckedTitle="SPONSOR"
                        callback={this.onProjectAwardedByChange}
                      />
                    ) : null}
                    {stateAndCentralFilter ? (
                      <ToggleBtn
                        checked={stateAndCentralFilterChecked}
                        checkedTitle="STATE"
                        uncheckedTitle="CENTRAL"
                        callback={this.onProjectCategoryByChange}
                        name={
                          stateAndCentralFilterChecked ? "CENTRAL" : "STATE"
                        }
                      />
                    ) : null}
                  </div>

                  <section className="summary-heading-download-section">
                    <DownloadExcelReport
                      isLoading={dashboardSummaryReducer.isLoading}
                      downloadLink={dashboardSummaryReducer.downloadingSrc}
                      onClearDownload={onClearDownloadDashboardSummary}
                      onStartDownloading={onDownloadDashboardSummary}
                    />
                    <CalendarFilter
                      calenderOptions={DASHBOARD_CALENDER}
                      displayDateTitle={displayDateTitle}
                      onChange={this.getFilterArrayValue}
                      defaultDates={{
                        displayDateTitle: get(filterArray, "dates")
                      }}
                    />
                  </section>
                </div>
                {summaryDataStatus === "SUCCESS" &&
                  (isDesktopView ? (
                    //project monitored
                    <div className="dashboard-graph-wrapper">
                      <Link
                        className="dashboard-link-tags graph-link"
                        to={{
                          pathname: PATHS.PROJECT_LIST,
                          isDashBoard: true,
                          summaryDataBy:
                            summaryDataBy &&
                            (groupCategory === "STATE" ||
                              groupCategory === "STATE_PMG" ||
                              groupCategory === "DISTRICT" ||
                              groupCategory === "STATE_DEPARTMENT"),
                          state: {
                            sponsoringMinistry:
                              getLocalstorage("summaryType") === "SPONSOR" &&
                              (groupCategory === "CENTRAL" ||
                                groupCategory === "CENTRAL_DEPARTMENT")
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],

                            recipientMinistry:
                              getLocalstorage("summaryType") === "RECIPIENT" &&
                              (groupCategory === "CENTRAL" ||
                                groupCategory === "CENTRAL_DEPARTMENT" ||
                                groupCategory === "STATE")
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : getLocalstorage("summaryType") ===
                                    "RECIPIENT" && groupCategory === "STATE_PMG"
                                ? [
                                    {
                                      key: user.childGroupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],
                            sponsoringState:
                              getLocalstorage("summaryType") === "SPONSOR" &&
                              groupCategory === "STATE"
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : getLocalstorage("summaryType") ===
                                    "SPONSOR" && groupCategory === "STATE_PMG"
                                ? [
                                    {
                                      key: user.childGroupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],
                            projectFlags: checkedValue
                              ? [{ displayName: "MARCH 24", key: "MARCH 24" }]
                              : null,
                            projectStage: [
                              { key: "VERIFIED", displayName: "VERIFIED" }
                            ],
                            // groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
                            //   groupCategory,
                            //   getLocalstorage("summaryType"),
                            //   stateAndCentralProjectSelectedBy
                            // ),
                            groupCategory: stateAndCentralProjectSelectedBy
                          }
                        }}
                      >
                        <Graph
                          className="dashboard-project-monitored"
                          svgColor="#fe4990"
                          gradientColor="#fdb6d6"
                          data={ProjectCount || {}}
                          icon={projectMonitored}
                        />
                      </Link>
                      <Link
                        //project value
                        className="dashboard-link-tags graph-link"
                        to={{
                          pathname: PATHS.PROJECT_LIST,
                          isDashBoard: true,
                          summaryDataBy:
                            summaryDataBy &&
                            (groupCategory === "STATE" ||
                              groupCategory === "STATE_PMG" ||
                              groupCategory === "DISTRICT" ||
                              groupCategory === "STATE_DEPARTMENT"),
                          state: {
                            sponsoringMinistry:
                              getLocalstorage("summaryType") === "SPONSOR" &&
                              (groupCategory === "CENTRAL" ||
                                groupCategory === "CENTRAL_DEPARTMENT")
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],
                            sponsoringState:
                              getLocalstorage("summaryType") === "SPONSOR" &&
                              groupCategory === "STATE"
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : getLocalstorage("summaryType") ===
                                    "SPONSOR" && groupCategory === "STATE_PMG"
                                ? [
                                    {
                                      key: user.childGroupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],
                            recipientMinistry:
                              getLocalstorage("summaryType") === "RECIPIENT" &&
                              (groupCategory === "CENTRAL" ||
                                groupCategory === "CENTRAL_DEPARTMENT" ||
                                groupCategory === "STATE")
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : getLocalstorage("summaryType") ===
                                    "RECIPIENT" && groupCategory === "STATE_PMG"
                                ? [
                                    {
                                      key: user.childGroupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],
                            projectFlags: checkedValue
                              ? [{ displayName: "MARCH 24", key: "MARCH 24" }]
                              : null,
                            projectStage: [
                              { key: "VERIFIED", displayName: "VERIFIED" }
                            ],
                            // groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
                            //   groupCategory,
                            //   getLocalstorage("summaryType"),
                            //   stateAndCentralProjectSelectedBy
                            // ),
                            groupCategory: stateAndCentralProjectSelectedBy
                          }
                        }}
                      >
                        <Graph
                          className="dashboard-project-value"
                          svgColor="#3536f3"
                          gradientColor="#d2d4fb"
                          data={ProjectCost || {}}
                          icon={projectValue}
                          isOverlayRequired={true}
                        />
                      </Link>
                      <Link
                        //pragati project
                        className="dashboard-link-tags graph-link"
                        to={{
                          pathname: PATHS.PROJECT_LIST,
                          isDashBoard: true,
                          summaryDataBy:
                            summaryDataBy &&
                            (groupCategory === "STATE" ||
                              groupCategory === "STATE_PMG" ||
                              groupCategory === "DISTRICT" ||
                              groupCategory === "STATE_DEPARTMENT"),
                          state: {
                            sponsoringMinistry:
                              getLocalstorage("summaryType") === "SPONSOR" &&
                              (groupCategory === "CENTRAL" ||
                                groupCategory === "CENTRAL_DEPARTMENT")
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],
                            sponsoringState:
                              getLocalstorage("summaryType") === "SPONSOR" &&
                              groupCategory === "STATE"
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : getLocalstorage("summaryType") ===
                                    "SPONSOR" && groupCategory === "STATE_PMG"
                                ? [
                                    {
                                      key: user.childGroupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],
                            recipientMinistry:
                              getLocalstorage("summaryType") === "RECIPIENT" &&
                              (groupCategory === "CENTRAL" ||
                                groupCategory === "CENTRAL_DEPARTMENT" ||
                                groupCategory === "STATE")
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : getLocalstorage("summaryType") ===
                                    "RECIPIENT" && groupCategory === "STATE_PMG"
                                ? [
                                    {
                                      key: user.childGroupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],
                            projectStage: [
                              { key: "VERIFIED", displayName: "VERIFIED" }
                            ],
                            // projectFlags: [
                            //   checkedValue
                            //     ? { displayName: "MARCH 24", key: "MARCH 24" }
                            //     : null,
                            //   { key: "PRAGATI", displayName: "Pragati" },
                            // ],
                            projectFlags: [
                              checkedValue
                                ? {
                                    displayName: "MARCH 24",
                                    key: "MARCH 24"
                                  }
                                : null,
                              {
                                key: "PRAGATI",
                                displayName: "PRAGATI"
                              }
                            ].filter(Boolean),
                            // groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
                            //   groupCategory,
                            //   getLocalstorage("summaryType"),
                            //   stateAndCentralProjectSelectedBy
                            // ),
                            groupCategory: stateAndCentralProjectSelectedBy
                          }
                        }}
                      >
                        <Graph
                          className="dashboard-pragati-projects"
                          svgColor="#17a27f"
                          gradientColor="#c9faed"
                          data={PragatiReview || {}}
                          icon={pragati}
                        />
                      </Link>
                      <Link
                        className="dashboard-link-tags graph-link issue-graph"
                        to={{
                          pathname: PATHS.ISSUE_LIST,
                          isDashBoard: true,
                          summaryDataBy:
                            summaryDataBy &&
                            (groupCategory === "STATE" ||
                              groupCategory === "STATE_PMG" ||
                              groupCategory === "DISTRICT" ||
                              groupCategory === "STATE_DEPARTMENT"),
                          state: {
                            projectFlags: checkedValue
                              ? [{ displayName: "MARCH 24", key: "MARCH 24" }]
                              : null,
                            sponsoringMinistry:
                              getLocalstorage("summaryType") === "SPONSOR" &&
                              (groupCategory === "CENTRAL" ||
                                groupCategory === "CENTRAL_DEPARTMENT")
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],
                            recipientCenter:
                              getLocalstorage("summaryType") === "RECIPIENT" &&
                              (groupCategory === "CENTRAL" ||
                                groupCategory === "CENTRAL_DEPARTMENT")
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],
                            sponsoringState:
                              getLocalstorage("summaryType") === "SPONSOR" &&
                              groupCategory === "STATE"
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : getLocalstorage("summaryType") ===
                                    "SPONSOR" && groupCategory === "STATE_PMG"
                                ? [
                                    {
                                      key: user.childGroupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],
                            recipientState:
                              groupCategory === "STATE" &&
                              getLocalstorage("summaryType") === "RECIPIENT"
                                ? [
                                    {
                                      key: user.groupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : getLocalstorage("summaryType") ===
                                    "RECIPIENT" && groupCategory === "STATE_PMG"
                                ? [
                                    {
                                      key: user.childGroupId.toString(),
                                      displayName: user.groupName
                                    }
                                  ]
                                : [],
                            projectStage: [
                              { key: "VERIFIED", displayName: "VERIFIED" }
                            ],

                            stages:
                              groupCategory === "PMG"
                                ? [
                                    {
                                      key: "955",
                                      displayName: "Pending with PMG"
                                    },
                                    {
                                      key: "963",
                                      displayName: "Pending with RM/RS"
                                    },
                                    {
                                      key: "968",
                                      displayName: "Under PMG Decision"
                                    },
                                    {
                                      key: "974",
                                      displayName: "RESOLVED"
                                    }
                                  ]
                                : ((groupCategory === "STATE_PMG" ||
                                    groupCategory === "STATE" ||
                                    isStateAndDistrictUser) &&
                                    getLocalstorage("summaryType") ===
                                      "SPONSOR") ||
                                  (stateAndCentralProjectSelectedBy ===
                                    "STATE" &&
                                    isStateAndDistrictUser &&
                                    groupCategory !== "STATE_DEPARTMENT")
                                ? [
                                    {
                                      key: "979",
                                      displayName: "Pending with State PMG"
                                    },

                                    {
                                      key: "980",
                                      displayName: "Pending with RD"
                                    },
                                    {
                                      key: "981",
                                      displayName: "Under State PMG Decision"
                                    },
                                    {
                                      key: "974",
                                      displayName: "RESOLVED"
                                    }
                                  ]
                                : ((groupCategory === "CENTRAL" ||
                                    isStateAndDistrictUser) &&
                                    (getLocalstorage("summaryType") ===
                                      "SPONSOR" ||
                                      getLocalstorage("summaryType") ===
                                        "RECIPIENT")) ||
                                  (stateAndCentralProjectSelectedBy ===
                                    "CENTRAL" &&
                                    isStateAndDistrictUser)
                                ? [
                                    {
                                      key: "955",
                                      displayName: "Pending with PMG"
                                    },
                                    {
                                      key: "968",
                                      displayName: "Under PMG Decision"
                                    },
                                    {
                                      key: "963",
                                      displayName: "Pending with RM/RS"
                                    },
                                    {
                                      key: "974",
                                      displayName: "RESOLVED"
                                    }
                                  ]
                                : (groupCategory === "STATE_PMG" ||
                                    groupCategory === "STATE" ||
                                    groupCategory === "PP" ||
                                    groupCategory === "CENTRAL_DEPARTMENT" ||
                                    groupCategory === "OTHER") &&
                                  !isStateAndDistrictUser &&
                                  (getLocalstorage("summaryType") ===
                                    "CENTRAL" ||
                                    getLocalstorage("summaryType") === null) &&
                                  stateAndCentralProjectSelectedBy === "CENTRAL"
                                ? [
                                    {
                                      key: "963",
                                      displayName: "Pending with RM/RS"
                                    },
                                    {
                                      key: "974",
                                      displayName: "RESOLVED"
                                    },
                                    {
                                      key: "968",
                                      displayName: "Under PMG Decision"
                                    },
                                    {
                                      key: "955",
                                      displayName: "Pending with PMG"
                                    }
                                  ]
                                : [
                                    {
                                      key: "963",
                                      displayName: "Pending with RM/RS"
                                    },
                                    {
                                      key: "974",
                                      displayName: "RESOLVED"
                                    },
                                    {
                                      key: "981",
                                      displayName: "Under State PMG Decision"
                                    },
                                    {
                                      key: "979",
                                      displayName: "Pending with State PMG"
                                    },
                                    {
                                      key: "982",
                                      displayName: "Under Central PMG"
                                    },
                                    {
                                      key: "980",
                                      displayName: "Pending with RD"
                                    },
                                    {
                                      key: "968",
                                      displayName: "Under PMG Decision"
                                    }
                                  ],
                            // groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
                            //   groupCategory,
                            //   getLocalstorage("summaryType"),
                            //   stateAndCentralProjectSelectedBy
                            // ),
                            groupCategory: stateAndCentralProjectSelectedBy
                          }
                        }}
                      >
                        <Graph
                          className="dashboard-issue-monitored"
                          svgColor="#ff6002"
                          gradientColor="#fbe0d0"
                          data={IssueCount || {}}
                          icon={issueMonitored}
                        />
                      </Link>
                    </div>
                  ) : (
                    <Slider {...settings}>
                      <Link
                        className="dashboard-link-tags graph-link"
                        to={{
                          pathname: PATHS.PROJECT_LIST,
                          isDashBoard: true,
                          summaryDataBy:
                            summaryDataBy &&
                            (groupCategory === "STATE" ||
                              groupCategory === "STATE_PMG" ||
                              groupCategory === "DISTRICT" ||
                              groupCategory === "STATE_DEPARTMENT"),
                          state: {
                            projectFlags: checkedValue
                              ? [{ displayName: "MARCH 24", key: "MARCH 24" }]
                              : null,
                            projectStage: [
                              { key: "VERIFIED", displayName: "VERIFIED" }
                            ],
                            groupCategory:
                              groupCategory === "CENTRAL"
                                ? "CENTRAL"
                                : summaryDataBy
                                ? "STATE"
                                : "CENTRAL"
                          }
                        }}
                      >
                        <Graph
                          className="dashboard-project-monitored"
                          svgColor="#fe4990"
                          gradientColor="#fdb6d6"
                          data={ProjectCount || {}}
                          icon={projectMonitored}
                        />
                      </Link>
                      <Link
                        className="dashboard-link-tags graph-link"
                        to={{
                          pathname: PATHS.PROJECT_LIST,
                          isDashBoard: true,
                          summaryDataBy:
                            summaryDataBy &&
                            (groupCategory === "STATE" ||
                              groupCategory === "STATE_PMG" ||
                              groupCategory === "DISTRICT" ||
                              groupCategory === "STATE_DEPARTMENT"),
                          state: {
                            projectFlags: checkedValue
                              ? [{ displayName: "MARCH 24", key: "MARCH 24" }]
                              : null,
                            projectStage: [
                              { key: "VERIFIED", displayName: "VERIFIED" }
                            ],
                            groupCategory:
                              groupCategory === "CENTRAL"
                                ? "CENTRAL"
                                : summaryDataBy
                                ? "STATE"
                                : "CENTRAL"
                          }
                        }}
                      >
                        <Graph
                          className="dashboard-project-value"
                          svgColor="#3536f3"
                          gradientColor="#d2d4fb"
                          data={ProjectCost || {}}
                          icon={projectValue}
                          isOverlayRequired={true}
                        />
                      </Link>
                      <Link
                        className="dashboard-link-tags graph-link"
                        to={{
                          pathname: PATHS.PROJECT_LIST,
                          isDashBoard: true,
                          summaryDataBy:
                            summaryDataBy &&
                            (groupCategory === "STATE" ||
                              groupCategory === "STATE_PMG" ||
                              groupCategory === "DISTRICT" ||
                              groupCategory === "STATE_DEPARTMENT"),
                          state: {
                            projectFlags: [
                              checkedValue
                                ? {
                                    displayName: "MARCH 24",
                                    key: "MARCH 24"
                                  }
                                : null,
                              {
                                key: "PRAGATI",
                                displayName: "PRAGATI"
                              }
                            ].filter(Boolean),
                            projectStage: [
                              { key: "VERIFIED", displayName: "VERIFIED" }
                            ],
                            groupCategory:
                              groupCategory === "CENTRAL"
                                ? "CENTRAL"
                                : summaryDataBy
                                ? "STATE"
                                : "CENTRAL"
                          }
                        }}
                      >
                        <Graph
                          className="dashboard-pragati-projects"
                          svgColor="#17a27f"
                          gradientColor="#c9faed"
                          data={PragatiReview || {}}
                          icon={pragati}
                        />
                      </Link>
                      <Link
                        className="dashboard-link-tags graph-link issue-graph"
                        to={{
                          pathname: PATHS.ISSUE_LIST,
                          isDashBoard: true,
                          summaryDataBy:
                            summaryDataBy &&
                            (groupCategory === "STATE" ||
                              groupCategory === "STATE_PMG" ||
                              groupCategory === "DISTRICT" ||
                              groupCategory === "STATE_DEPARTMENT"),
                          state: {
                            projectFlags: checkedValue
                              ? [{ displayName: "MARCH 24", key: "MARCH 24" }]
                              : null,
                            projectStage: [
                              { key: "VERIFIED", displayName: "VERIFIED" }
                            ],
                            groupCategory:
                              groupCategory === "CENTRAL"
                                ? "CENTRAL"
                                : summaryDataBy
                                ? "STATE"
                                : "CENTRAL"
                          }
                        }}
                      >
                        <Graph
                          className="dashboard-issue-monitored"
                          svgColor="#ff6002"
                          gradientColor="#fbe0d0"
                          data={IssueCount || {}}
                          icon={issueMonitored}
                        />
                      </Link>
                    </Slider>
                  ))}
              </div>

              {isDesktopView ? (
                <div
                  className={"pending-tasks odd pending-tasks-border-bottom"}
                >
                  <div
                    className="mobile-heading"
                    onClick={() => this.taskStatusResult(1)}
                  >
                    <h3>
                      Pending Tasks{" "}
                      {(isValidArray(pendingTask) && (
                        <span>
                          {" "}
                          ({pendingTask[0][1].length + pendingTask[1][1].length}
                          )
                        </span>
                      )) ||
                        null}
                    </h3>
                    {/* {this.renderPendingTaskZoneDropdown()} */}
                    <div
                      //className="dashboard-new-dropdown"
                      className="dashboard-new-dropdown pending-task-zone-dropdown"
                      //onClick={(e) => e.stopPropagation()}
                      style={{ visibility: isVisible ? "visible" : "hidden" }}
                    >
                      <Dropdown
                        key={panelKey}
                        options={this.state.zoneOptions}
                        optionLabel="label"
                        className="pending-task-by-zone"
                        onHide={this.handleHide}
                        value={pendingTaskZoneSelect}
                        onChange={e => this.pendingTaskByZone(e)}
                        placeholder="Select Zone"
                        name="pendingTaskZoneSelect"
                        appendTo="self"
                        // appendTo={document.body}
                      />
                    </div>
                  </div>
                  <div
                    className={`pending-tasks-inner popover-wrapper ${
                      taskStatus === 1 ? "link-display" : ""
                    }`}
                  >
                    {" "}
                    {/* popover-visible */}
                    <div
                      className="dashboard-heading-wrapper popover-title"
                      style={{
                        borderBottom: !pendingCommentsVisible
                          ? null
                          : "1px transparent"
                      }}
                    >
                      <div
                        className="back-btn"
                        onClick={() => this.taskStatusResult(1)}
                      />
                      <h3>
                        Pending Tasks{" "}
                        {(isValidArray(pendingTask) && (
                          <span>
                            (
                            {pendingTask[0][1].length +
                              pendingTask[1][1].length +
                              (pendingComments ? pendingComments.length : 0)}
                            )
                          </span>
                        )) ||
                          null}
                      </h3>
                      {/* {this.renderPendingTaskZoneDropdown()} */}
                      <div
                        //className="dashboard-new-dropdown"
                        className="dashboard-new-dropdown pending-task-zone-dropdown"
                        //onClick={(e) => e.stopPropagation()}
                        style={{ visibility: isVisible ? "visible" : "hidden" }}
                      >
                        <Dropdown
                          key={panelKey}
                          options={this.state.zoneOptions}
                          optionLabel="label"
                          className="pending-task-by-zone"
                          onHide={this.handleHide}
                          value={pendingTaskZoneSelect}
                          onChange={e => this.pendingTaskByZone(e)}
                          placeholder="Select Zone"
                          name="pendingTaskZoneSelect"
                          appendTo="self"
                          // appendTo={document.body}
                        />
                      </div>
                    </div>
                    {!pendingCommentsVisible ? (
                      <div
                        className={`dashboard-cards pending-tasks-section ${
                          resolveToggle ? "pending-action-open" : ""
                        }`}
                        style={{ maxHeight: "425px" }}
                      >
                        {" "}
                        {/* pending-action-open - class when action item is open*/}
                        {(pendingTaskLoading && (
                          <Col lg>
                            <LoaderTemplate
                              height={117}
                              children={<SideBarListingTemplate />}
                            />
                          </Col>
                        )) || (
                            <section>
                              {(!isValidArray(pendingTask) && (
                                <NoDataFound pendingTask />
                              )) ||
                                null}
                              {(isValidArray(pendingTask) &&
                                pendingTask.map((task, key) => {
                                  return isValidArray(task[1]) &&
                                    task[1].length > 0 ? (
                                    <Cards
                                      classes="pending-task-card"
                                      options={task[1]}
                                      key={task[0]}
                                      classForPadding={
                                        user.groupCategory !== "PMG"
                                          ? true
                                          : false
                                      }
                                      titleTemplate={option => (
                                        <>
                                          <h4 className="dashboard-link-tags">
                                            {task[0] === "projects"
                                              ? "Project "
                                              : "Issue "}
                                            {task[0] === "projects" ? (
                                              <Link
                                                to={{
                                                  pathname:
                                                    PATHS.PROJECT_DETAILS,
                                                  search: `?projectId=${
                                                    option.projectId
                                                  }`
                                                }}
                                              >
                                                #{option.displayId}
                                              </Link>
                                            ) : (
                                              <Link
                                                to={{
                                                  pathname: PATHS.ISSUE_DETAIL,
                                                  search: `?issueId=${
                                                    option.issueId
                                                  }&&projectId=${
                                                    option.projectId
                                                  }`
                                                }}
                                              >
                                                #{option.displayId}
                                              </Link>
                                            )}
                                          </h4>
                                          <span
                                            style={{
                                              float: "right",
                                              position: "relative",
                                              top: "-25px"
                                            }}
                                          >
                                            {task[0] === "projects" ? (
                                              <div>
                                                <Button
                                                  className={`btn-extra-small animated flipInX unClickable ${getColor(
                                                    option.clarification
                                                      ? null
                                                      : get(
                                                          option,
                                                          "status"
                                                        ).toLowerCase()
                                                  )}`}
                                                  style={{
                                                    padding: "2px 5px",
                                                    fontSize: "11px",
                                                    height: "20px",
                                                    borderRadius: "15px",
                                                    textTransform: "uppercase"
                                                  }}
                                                >
                                                  {option.clarification
                                                    ? "Assigned for Clarification"
                                                    : option.issueId
                                                    ? option.status
                                                    : get(option, "status")
                                                        .replace(/[_]/, " ")
                                                        .toLowerCase()}
                                                </Button>
                                              </div>
                                            ) : (
                                              <OverlayTrigger
                                                defaultShow={false}
                                                trigger="hover"
                                                placement="top"
                                                overlay={
                                                  <Tooltip className="issues-status-tooltip ">
                                                    {toolttipDisplayMessage(
                                                      option.clarification
                                                        ? "Assigned for Clarification"
                                                        : option.issueId
                                                        ? option.status
                                                        : get(option, "status")
                                                            .replace(/[_]/, " ")
                                                            .toLowerCase()
                                                    )}
                                                    {/* {option.clarification} */}
                                                  </Tooltip>
                                                }
                                              >
                                                <div>
                                                  <Button
                                                    className={`btn-extra-small animated flipInX unClickable ${getColor(
                                                      option.clarification
                                                        ? null
                                                        : get(
                                                            option,
                                                            "status"
                                                          ).toLowerCase()
                                                    )}`}
                                                    style={{
                                                      padding: "2px 5px",
                                                      fontSize: "11px",
                                                      height: "20px",
                                                      borderRadius: "15px",
                                                      textTransform: "uppercase"
                                                    }}
                                                  >
                                                    {option.clarification
                                                      ? "Assigned for Clarification"
                                                      : option.issueId
                                                      ? option.status
                                                      : get(option, "status")
                                                          .replace(/[_]/, " ")
                                                          .toLowerCase()}
                                                  </Button>
                                                </div>
                                              </OverlayTrigger>
                                            )}
                                            <div className="dashboard-pending-task-area">
                                              <Image
                                                src={IconTime}
                                                alt="Time"
                                              />
                                              <span
                                                style={{
                                                  paddingTop: "2px",
                                                  paddingLeft: "4px"
                                                }}
                                              >
                                                {getIssueAssigneeDate(option)}
                                              </span>
                                            </div>
                                          </span>
                                        </>
                                      )}
                                      bodyTemplate={option => {
                                        const title =
                                          option && option.title
                                            ? option.title
                                            : option.comment
                                            ? option.comment.replace(
                                                /<[^>]+>/g,
                                                ""
                                              )
                                            : "";

                                        const isHindi = title.match(
                                          /[\u0900-\u097F]/
                                        );

                                        return (
                                          <>
                                            <h4
                                              className={`${
                                                isHindi ? "hindi-text-wrap" : ""
                                              }`}
                                              style={{
                                                lineHeight: isHindi ? 1.3 : "",
                                                top: isHindi ? "2px" : "",
                                                position: isHindi
                                                  ? "relative"
                                                  : ""
                                              }}
                                            >
                                              {title}
                                            </h4>
                                            {user.groupCategory === "PMG" && (
                                              <div>
                                                {option.imageUrl != null && (
                                                  <Image
                                                    style={{
                                                      width: "24px"
                                                    }}
                                                    src={option.imageUrl}
                                                  />
                                                )}
                                                <span className="pending-task-location">
                                                  {option.issueLocation}
                                                </span>
                                              </div>
                                            )}
                                          </>
                                        );
                                      }}
                                    />
                                  ) : null;
                                })) ||
                                null}
                            </section>
                          ) ||
                          null}
                      </div>
                    ) : null}
                    <div
                      className="tabs-container"
                      style={{
                        display: !pendingCommentsVisible ? "none" : null
                      }}
                    >
                      <div className="dashboard-tabs">
                        <div
                          className={`dashboard-tab ${
                            activeTab === "projects" ? "active" : ""
                          }`}
                          onClick={() => this.handleTabChange("projects")}
                        >
                          Projects/Issues{" "}
                          {(isValidArray(pendingTask) && (
                            <span>
                              (
                              {pendingTask[0][1].length +
                                pendingTask[1][1].length}
                              )
                            </span>
                          )) ||
                            null}
                        </div>

                        <div
                          className={`dashboard-tab ${
                            activeTab === "comments" ? "active" : ""
                          }`}
                          onClick={() => this.handleTabChange("comments")}
                        >
                          Pending Comments{" "}
                          {pendingComments.length === 0
                            ? null
                            : `(${pendingComments.length})`}
                        </div>
                      </div>

                      <div className="tab-content">
                        {activeTab === "projects" && (
                          <div
                            className={`dashboard-cards pending-tasks-section ${
                              resolveToggle ? "pending-action-open" : ""
                            }`}
                            style={{ maxHeight: "425px" }}
                          >
                            {" "}
                            {/* pending-action-open - class when action item is open*/}
                            {(pendingTaskLoading && (
                              <Col lg>
                                <LoaderTemplate
                                  height={117}
                                  children={<SideBarListingTemplate />}
                                />
                              </Col>
                            )) || (
                                <section>
                                  {(!isValidArray(pendingTask) && (
                                    <NoDataFound pendingTask />
                                  )) ||
                                    null}
                                  {(isValidArray(pendingTask) &&
                                    pendingTask.map((task, key) => {
                                      return isValidArray(task[1]) &&
                                        task[1].length > 0 ? (
                                        <Cards
                                          classes="pending-task-card"
                                          options={task[1]}
                                          key={task[0]}
                                          classForPadding={
                                            user.groupCategory !== "PMG"
                                              ? true
                                              : false
                                          }
                                          titleTemplate={option => (
                                            <>
                                              <h4 className="dashboard-link-tags">
                                                {task[0] === "projects"
                                                  ? "Project "
                                                  : "Issue "}
                                                {task[0] === "projects" ? (
                                                  <Link
                                                    to={{
                                                      pathname:
                                                        PATHS.PROJECT_DETAILS,
                                                      search: `?projectId=${
                                                        option.projectId
                                                      }`
                                                    }}
                                                  >
                                                    #{option.displayId}
                                                  </Link>
                                                ) : (
                                                  <Link
                                                    to={{
                                                      pathname:
                                                        PATHS.ISSUE_DETAIL,
                                                      search: `?issueId=${
                                                        option.issueId
                                                      }&&projectId=${
                                                        option.projectId
                                                      }`
                                                    }}
                                                  >
                                                    #{option.displayId}
                                                  </Link>
                                                )}
                                              </h4>
                                              <span
                                                style={{
                                                  float: "right",
                                                  position: "relative",
                                                  top: "-25px"
                                                }}
                                              >
                                                {task[0] === "projects" ? (
                                                  <div>
                                                    <Button
                                                      className={`btn-extra-small animated flipInX unClickable ${getColor(
                                                        option.clarification
                                                          ? null
                                                          : get(
                                                              option,
                                                              "status"
                                                            ).toLowerCase()
                                                      )}`}
                                                      style={{
                                                        padding: "2px 5px",
                                                        fontSize: "11px",
                                                        height: "20px",
                                                        borderRadius: "15px",
                                                        textTransform:
                                                          "uppercase"
                                                      }}
                                                    >
                                                      {option.clarification
                                                        ? "Assigned for Clarification"
                                                        : option.issueId
                                                        ? option.status
                                                        : get(option, "status")
                                                            .replace(/[_]/, " ")
                                                            .toLowerCase()}
                                                    </Button>
                                                  </div>
                                                ) : (
                                                  <OverlayTrigger
                                                    defaultShow={false}
                                                    trigger="hover"
                                                    placement="top"
                                                    overlay={
                                                      <Tooltip className="issues-status-tooltip ">
                                                        {toolttipDisplayMessage(
                                                          option.clarification
                                                            ? "Assigned for Clarification"
                                                            : option.issueId
                                                            ? option.status
                                                            : get(
                                                                option,
                                                                "status"
                                                              )
                                                                .replace(
                                                                  /[_]/,
                                                                  " "
                                                                )
                                                                .toLowerCase()
                                                        )}
                                                        {/* {option.clarification} */}
                                                      </Tooltip>
                                                    }
                                                  >
                                                    <div>
                                                      <Button
                                                        className={`btn-extra-small animated flipInX unClickable ${getColor(
                                                          option.clarification
                                                            ? null
                                                            : get(
                                                                option,
                                                                "status"
                                                              ).toLowerCase()
                                                        )}`}
                                                        style={{
                                                          padding: "2px 5px",
                                                          fontSize: "11px",
                                                          height: "20px",
                                                          borderRadius: "15px",
                                                          textTransform:
                                                            "uppercase"
                                                        }}
                                                      >
                                                        {option.clarification
                                                          ? "Assigned for Clarification"
                                                          : option.issueId
                                                          ? option.status
                                                          : get(
                                                              option,
                                                              "status"
                                                            )
                                                              .replace(
                                                                /[_]/,
                                                                " "
                                                              )
                                                              .toLowerCase()}
                                                      </Button>
                                                    </div>
                                                  </OverlayTrigger>
                                                )}
                                                <div className="dashboard-pending-task-area">
                                                  <Image
                                                    src={IconTime}
                                                    alt="Time"
                                                  />
                                                  <span
                                                    style={{
                                                      paddingTop: "2px",
                                                      paddingLeft: "4px"
                                                    }}
                                                  >
                                                    {getIssueAssigneeDate(
                                                      option
                                                    )}
                                                  </span>
                                                </div>
                                              </span>
                                            </>
                                          )}
                                          bodyTemplate={option => {
                                            const title =
                                              option && option.title
                                                ? option.title
                                                : option.comment
                                                ? option.comment.replace(
                                                    /<[^>]+>/g,
                                                    ""
                                                  )
                                                : "";

                                            const isHindi = title.match(
                                              /[\u0900-\u097F]/
                                            );

                                            return (
                                              <>
                                                <h4
                                                  className={`${
                                                    option.title.match(
                                                      /[\u0900-\u097F]/
                                                    )
                                                      ? "hindi-text-wrap"
                                                      : ""
                                                  }`}
                                                  style={{
                                                    lineHeight: option.title.match(
                                                      /[\u0900-\u097F]/
                                                    )
                                                      ? 1.3
                                                      : "",
                                                    top: option.title.match(
                                                      /[\u0900-\u097F]/
                                                    )
                                                      ? "2px"
                                                      : "",
                                                    position: option.title.match(
                                                      /[\u0900-\u097F]/
                                                    )
                                                      ? "relative"
                                                      : ""
                                                  }}
                                                >
                                                  {option.title}
                                                </h4>
                                                {user.groupCategory ===
                                                  "PMG" && (
                                                  <div>
                                                    {option.imageUrl !=
                                                      null && (
                                                      <Image
                                                        style={{
                                                          width: "24px"
                                                        }}
                                                        src={option.imageUrl}
                                                      />
                                                    )}
                                                    <span className="pending-task-location">
                                                      {option.issueLocation}
                                                    </span>
                                                  </div>
                                                )}
                                              </>
                                            );
                                          }}
                                        />
                                      ) : null;
                                    })) ||
                                    null}
                                </section>
                              ) ||
                              null}
                          </div>
                        )}
                        {activeTab === "comments" && (
                          <div
                            className={`dashboard-cards pending-tasks-section ${
                              resolveToggle ? "pending-action-open" : ""
                            }`}
                            //style={{ maxHeight: "425px" }}
                          >
                            {(pendingCommentsStatus && (
                              <Col lg>
                                <LoaderTemplate
                                  height={117}
                                  children={<SideBarListingTemplate />}
                                />
                              </Col>
                            )) || (
                                <section>
                                  {(!isValidArray(pendingComments) && (
                                    <NoDataFound pendingComments />
                                  )) ||
                                    null}
                                  {pendingComments &&
                                    Array.isArray(pendingComments) &&
                                    pendingComments.length > 0 &&
                                    pendingComments.map((item, index, arr) => (
                                      <div
                                        key={item.commentId || index}
                                        className="pending-comments"
                                        style={{
                                          borderBottom:
                                            index !== arr.length - 1
                                              ? "1px solid #ddd"
                                              : "none"
                                        }}
                                      >
                                        {/* Title */}
                                        <h3 className="pending-issue-title">
                                          Issue{" "}
                                          <Link
                                            to={{
                                              pathname: PATHS.ISSUE_DETAIL,
                                              search: `?issueId=${
                                                item.issueId
                                              }&&projectId=${item.projectId}`
                                            }}
                                          >
                                            #{item.issueDisplayId}
                                          </Link>
                                          {/* <span className="pending-issue-id">
          
        </span> */}
                                        </h3>

                                        {/* Meta */}
                                        <p className="pending-issue-meta">
                                          {moment(item.date).format(
                                            "DD/MM/YYYY, hh:mm A"
                                          )}{" "}
                                          |{" "}
                                          <span className="pending-issue-user">
                                            {item.createdBy}
                                          </span>
                                        </p>

                                        {/* Description (HTML content) */}
                                        <div
                                          className="pending-issue-desc"
                                          dangerouslySetInnerHTML={{
                                            __html: item.comment
                                          }}
                                        />
                                        {(isValidArray(
                                          item.fileManagerDTOSet
                                        ) && (
                                          <section
                                            class="display-attachments-section-issue-comments attachments"
                                            style={{
                                              marginBottom: 5,
                                              paddingTop: 0
                                            }}
                                          >
                                            <div class="uploaded-file-wrapper-issue-comments">
                                              {item.fileManagerDTOSet.map(
                                                file => {
                                                  const extension = file.name.substr(
                                                    file.name.lastIndexOf(".") +
                                                      1,
                                                    file.name.length
                                                  );
                                                  return (
                                                    <div
                                                      class="uploaded-file-issue-comments"
                                                      onClick={() =>
                                                        window.open(
                                                          file.s3Url,
                                                          "_blank"
                                                        )
                                                      }
                                                      style={{
                                                        padding: this.padding(
                                                          zoomPercentage
                                                        )
                                                      }}
                                                    >
                                                      <div class="file-detail">
                                                        <div>
                                                          <div class="upload-icon">
                                                            <span>
                                                              {extension}
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <a
                                                          target="_blank"
                                                          href={file.s3Url}
                                                          style={{
                                                            fontSize: this.fontSize(
                                                              zoomPercentage
                                                            ),
                                                            paddingLeft: this.paddingLeft(
                                                              zoomPercentage
                                                            )
                                                          }}
                                                        >
                                                          {file.title
                                                            ? file.title
                                                                .length > 20
                                                              ? file.title.substring(
                                                                  0,
                                                                  18
                                                                ) + ".."
                                                              : file.title
                                                            : file.name
                                                            ? file.name.length >
                                                              20
                                                              ? file.name.substring(
                                                                  0,
                                                                  18
                                                                ) + ".."
                                                              : file.name
                                                            : ""}
                                                        </a>
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              ) || null}
                                            </div>
                                          </section>
                                        )) ||
                                          null}
                                        {/* Actions */}
                                        <div
                                          style={{
                                            display: item.canApprove
                                              ? "flex"
                                              : "none"
                                          }}
                                        >
                                          <Approve
                                            commentId={item.commentId}
                                            getAllComments={this.getAllComments}
                                          />
                                          <ModifyAndApprove
                                            history={item.comment}
                                            commentId={item.commentId}
                                            getAllComments={this.getAllComments}
                                            file={item.fileManagerDTOSet}
                                            displayLoader={this.displayLoader}
                                            //dashboardPage={true}
                                          />
                                        </div>
                                      </div>
                                    ))}
                                </section>
                              ) ||
                              null}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {groupCategory === "PMG" ? (
                <section className="pdf-container" style={{ paddingTop: 0 }}>
                  <FirstPage
                    displayOnDashboard={true}
                    dashboardClass="dashboard-charts"
                    isDesktopView={isDesktopView}
                    checkedValue={checkedValue}
                  />
                </section>
              ) : null}

              {isDesktopView ? null : (
                <div className="pending-tasks odd">
                  <div
                    className="mobile-heading"
                    onClick={() => this.taskStatusResult(1)}
                  >
                    <h3>
                      Pending Tasksssssssss{" "}
                      {(isValidArray(pendingTask) && (
                        <span>
                          {" "}
                          ({pendingTask[0][1].length + pendingTask[1][1].length}
                          )
                        </span>
                      )) ||
                        null}
                    </h3>
                  </div>
                  <div
                    className={`pending-tasks-inner popover-wrapper ${
                      taskStatus === 1 ? "link-display" : ""
                    }`}
                  >
                    {" "}
                    {/* popover-visible */}
                    <div className="dashboard-heading-wrapper popover-title">
                      <div
                        className="back-btn"
                        onClick={() => this.taskStatusResult(1)}
                      />
                      <h3>
                        Pending Tasks{" "}
                        {(isValidArray(pendingTask) && (
                          <span>
                            (
                            {pendingTask[0][1].length +
                              pendingTask[1][1].length}
                            )
                          </span>
                        )) ||
                          null}
                      </h3>
                      {/* {this.renderPendingTaskZoneDropdown()} */}
                      <div
                        //className="dashboard-new-dropdown"
                        className="dashboard-new-dropdown pending-task-zone-dropdown"
                        //onClick={(e) => e.stopPropagation()}
                        style={{ visibility: isVisible ? "visible" : "hidden" }}
                      >
                        <Dropdown
                          key={panelKey}
                          options={this.state.zoneOptions}
                          optionLabel="label"
                          className="pending-task-by-zone"
                          onHide={this.handleHide}
                          value={pendingTaskZoneSelect}
                          onChange={e => this.pendingTaskByZone(e)}
                          placeholder="Select Zone"
                          name="pendingTaskZoneSelect"
                          appendTo="self"
                          // appendTo={document.body}
                        />
                      </div>
                    </div>
                    <div
                      className={`dashboard-cards pending-tasks-section ${
                        resolveToggle ? "pending-action-open" : ""
                      }`}
                      style={{ maxHeight: "425px" }}
                    >
                      {" "}
                      {/* pending-action-open - class when action item is open*/}
                      {(pendingTaskLoading && (
                        <Col lg>
                          <LoaderTemplate
                            height={117}
                            children={<SideBarListingTemplate />}
                          />
                        </Col>
                      )) || (
                          <section>
                            {(!isValidArray(pendingTask) && (
                              <NoDataFound pendingTask />
                            )) ||
                              null}
                            {(isValidArray(pendingTask) &&
                              pendingTask.map((task, key) => {
                                return isValidArray(task[1]) ? (
                                  <Cards
                                    classes="pending-task-card"
                                    options={task[1]}
                                    key={task[0]}
                                    classForPadding={
                                      user.groupCategory !== "PMG"
                                        ? true
                                        : false
                                    }
                                    titleTemplate={option => (
                                      <>
                                        <h4 className="dashboard-link-tags">
                                          {task[0] === "projects"
                                            ? "Project "
                                            : "Issue "}
                                          {task[0] === "projects" ? (
                                            <Link
                                              to={{
                                                pathname: PATHS.PROJECT_DETAILS,
                                                search: `?projectId=${
                                                  option.projectId
                                                }`
                                              }}
                                            >
                                              #{option.displayId}
                                            </Link>
                                          ) : (
                                            <Link
                                              to={{
                                                pathname: PATHS.ISSUE_DETAIL,
                                                search: `?issueId=${
                                                  option.issueId
                                                }&&projectId=${
                                                  option.projectId
                                                }`
                                              }}
                                            >
                                              #{option.displayId}
                                            </Link>
                                          )}
                                        </h4>
                                        <span
                                          style={{
                                            float: "right",
                                            position: "relative",
                                            top: "-25px"
                                          }}
                                        >
                                          {task[0] === "projects" ? (
                                            <div>
                                              <Button
                                                className={`btn-extra-small animated flipInX unClickable ${getColor(
                                                  option.clarification
                                                    ? null
                                                    : get(
                                                        option,
                                                        "status"
                                                      ).toLowerCase()
                                                )}`}
                                                style={{
                                                  padding: "2px 5px",
                                                  fontSize: "11px",
                                                  height: "20px",
                                                  borderRadius: "15px",
                                                  textTransform: "uppercase"
                                                }}
                                              >
                                                {option.clarification
                                                  ? "Assigned for Clarification"
                                                  : option.issueId
                                                  ? option.status
                                                  : get(option, "status")
                                                      .replace(/[_]/, " ")
                                                      .toLowerCase()}
                                              </Button>
                                            </div>
                                          ) : (
                                            <OverlayTrigger
                                              defaultShow={false}
                                              trigger="hover"
                                              placement="top"
                                              overlay={
                                                <Tooltip className="issues-status-tooltip ">
                                                  {toolttipDisplayMessage(
                                                    option.clarification
                                                      ? "Assigned for Clarification"
                                                      : option.issueId
                                                      ? option.status
                                                      : get(option, "status")
                                                          .replace(/[_]/, " ")
                                                          .toLowerCase()
                                                  )}
                                                  {/* {option.clarification} */}
                                                </Tooltip>
                                              }
                                            >
                                              <div>
                                                <Button
                                                  className={`btn-extra-small animated flipInX unClickable ${getColor(
                                                    option.clarification
                                                      ? null
                                                      : get(
                                                          option,
                                                          "status"
                                                        ).toLowerCase()
                                                  )}`}
                                                  style={{
                                                    padding: "2px 5px",
                                                    fontSize: "11px",
                                                    height: "20px",
                                                    borderRadius: "15px",
                                                    textTransform: "uppercase"
                                                  }}
                                                >
                                                  {option.clarification
                                                    ? "Assigned for Clarification"
                                                    : option.issueId
                                                    ? option.status
                                                    : get(option, "status")
                                                        .replace(/[_]/, " ")
                                                        .toLowerCase()}
                                                </Button>
                                              </div>
                                            </OverlayTrigger>
                                          )}
                                          <div className="dashboard-pending-task-area">
                                            <Image src={IconTime} alt="Time" />
                                            <span
                                              style={{
                                                paddingTop: "2px",
                                                paddingLeft: "4px"
                                              }}
                                            >
                                              {getIssueAssigneeDate(option)}
                                            </span>
                                          </div>
                                        </span>
                                      </>
                                    )}
                                    bodyTemplate={option => (
                                      <>
                                        <h4
                                          className={`${
                                            option.title.match(
                                              /[\u0900-\u097F]/
                                            )
                                              ? "hindi-text-wrap"
                                              : ""
                                          }`}
                                          style={{
                                            lineHeight: option.title.match(
                                              /[\u0900-\u097F]/
                                            )
                                              ? 1.3
                                              : "",
                                            top: option.title.match(
                                              /[\u0900-\u097F]/
                                            )
                                              ? "2px"
                                              : "",
                                            position: option.title.match(
                                              /[\u0900-\u097F]/
                                            )
                                              ? "relative"
                                              : ""
                                          }}
                                        >
                                          {option.title}
                                        </h4>
                                        {user.groupCategory === "PMG" && (
                                          <div>
                                            {option.imageUrl != null && (
                                              <Image
                                                style={{ width: "24px" }}
                                                src={option.imageUrl}
                                              />
                                            )}
                                            <span className="pending-task-location">
                                              {option.issueLocation}
                                            </span>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  />
                                ) : null;
                              })) ||
                              null}
                          </section>
                        ) ||
                        null}
                    </div>
                  </div>
                </div>
              )}

              <DisplayByPermission display={get(permission, "delayProjects")}>
                <div className="delayed-project">
                  <div
                    className="mobile-heading"
                    onClick={() => this.taskStatusResult(9)}
                  >
                    <h3>Delayed Projects</h3>
                  </div>
                  <div
                    className={`pending-tasks-inner popover-wrapper ${
                      taskStatus === 9 ? "link-display" : ""
                    }`}
                  >
                    {" "}
                    {/* popover-visible */}
                    <div className="dashboard-heading-wrapper popover-title">
                      <div
                        className="back-btn"
                        onClick={() => this.taskStatusResult(9)}
                      />
                      <h3>Delayed Projects</h3>
                      <div className="dashboard-new-dropdown">
                        <Dropdown
                          key={panelKey}
                          options={this.state.implementationMode}
                          optionLabel="name"
                          onHide={this.handleHide}
                          value={delayedProjectModeSelect}
                          onChange={e => this.delayedProject(e)}
                          placeholder="All"
                          name="delayedProjectModeSelect"
                          appendTo="self"
                        />
                      </div>
                      {/* <Form className="project-by-filters">
                       
                        <Form.Group className="field-select">
                          <Form.Control
                            value={delayedProjectModeSelect}
                            as="select"
                            onChange={this.onSelectChange}
                            name="delayedProjectModeSelect"
                          >
                            <option value="">All</option>
                            <option value="PUBLIC">Public</option>
                            <option selected value="PRIVATE">
                              Private
                            </option>
                            <option value="PPP">PPP</option>
                            <option value="NA">NA</option>
                          </Form.Control>
                        </Form.Group> 
                      </Form> */}
                    </div>
                    <table
                      className={
                        delayedProjectStatus === STATUS.LOADING
                          ? "make-table"
                          : delayedProjectData && delayedProjectData.length
                          ? ""
                          : "remove-scroll"
                      }
                    >
                      {
                        <thead>
                          {delayedProjectData && delayedProjectData.length ? (
                            <tr>
                              <th>Ministry Name</th>
                              {headingsForDelayedProject &&
                              headingsForDelayedProject.length
                                ? headingsForDelayedProject.map(
                                    (item, index) => {
                                      return (
                                        <th
                                          className={`sort-by ${
                                            this.state[item.key]
                                              ? this.state[item.key]
                                              : "asc"
                                          }`}
                                          onClick={() =>
                                            this.sortTimelineTableData(
                                              item.key,
                                              headingsForDelayedProject
                                            )
                                          }
                                        >
                                          {item.key}
                                        </th>
                                      );
                                    }
                                  )
                                : null}
                            </tr>
                          ) : null}
                        </thead>
                      }
                      {(delayedProjectStatus === STATUS.LOADING && (
                        <TableLoaderTemplate
                          height={60}
                          children={<IssuePendingLoader />}
                        />
                      )) || (
                        <tbody>
                          {isValidArray(delayedProjectData) ? (
                            isEmptyProject ? (
                              <tr align="center">
                                <td>
                                  <NoDataFound />
                                </td>
                              </tr>
                            ) : (
                              templateDelayedProject
                            )
                          ) : (
                            (
                              <tr align="center">
                                <td>
                                  <NoDataFound />
                                </td>
                              </tr>
                            ) || null
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </DisplayByPermission>

              <DisplayByPermission
                display={get(permission, "costOverrunDashboard")}
              >
                <div className="cost-overrun-project">
                  <div
                    className="mobile-heading"
                    onClick={() => this.taskStatusResult(10)}
                  >
                    <h3>Project Cost Overrun (%)</h3>
                  </div>
                  <div
                    className={`pending-tasks-inner popover-wrapper ${
                      taskStatus === 10 ? "link-display" : ""
                    }`}
                  >
                    {" "}
                    <div className="dashboard-heading-wrapper popover-title">
                      <div
                        className="back-btn"
                        onClick={() => this.taskStatusResult(10)}
                      />
                      <h3>Project Cost Overrun (%)</h3>
                      <div className="dashboard-new-dropdown">
                        <Dropdown
                          key={panelKey}
                          options={this.state.implementationMode}
                          optionLabel="name"
                          onHide={this.handleHide}
                          value={costOverrunProjectModeSelect}
                          onChange={e => this.costOverrunProjectModeSelect(e)}
                          placeholder="All"
                          name="costOverrunProjectModeSelect"
                          appendTo="self"
                        />
                      </div>
                      {/* <Form className="project-by-filters">
                        <Form.Group className="field-select">
                          <Form.Control
                            value={costOverrunProjectModeSelect}
                            as="select"
                            onChange={this.onSelectChange}
                            name="costOverrunProjectModeSelect"
                          >
                            <option value="">All</option>
                            <option value="PUBLIC">Public</option>
                            <option selected value="PRIVATE">
                              Private
                            </option>
                            <option value="PPP">PPP</option>
                            <option value="NA">NA</option>
                          </Form.Control>
                        </Form.Group>
                      </Form> */}
                    </div>
                    <table
                      className={
                        costOverrunProjectStatus === STATUS.LOADING
                          ? "make-table"
                          : costOverrunProjectData &&
                            costOverrunProjectData.length
                          ? ""
                          : "remove-scroll"
                      }
                    >
                      <thead>
                        {costOverrunProjectData &&
                        costOverrunProjectData.length ? (
                          <tr>
                            <th>Ministry Name</th>
                            {headingsForCostOverrunProject &&
                            headingsForCostOverrunProject.length
                              ? headingsForCostOverrunProject.map(
                                  (item, index) => {
                                    return (
                                      <th
                                        className={`sort-by ${
                                          this.state[item.key]
                                            ? this.state[item.key]
                                            : "asc"
                                        }`}
                                        onClick={() =>
                                          this.sortCostOverrunTimelineTableData(
                                            item.key,
                                            headingsForCostOverrunProject
                                          )
                                        }
                                      >
                                        {item.key}
                                      </th>
                                    );
                                  }
                                )
                              : null}
                          </tr>
                        ) : null}
                      </thead>
                      {(costOverrunProjectStatus === STATUS.LOADING && (
                        <TableLoaderTemplate
                          height={60}
                          children={<IssuePendingLoader />}
                        />
                      )) || (
                        <tbody>
                          {isValidArray(costOverrunProjectData) ? (
                            isEmptyProject ? (
                              <tr align="center">
                                <td>
                                  <NoDataFound />
                                </td>
                              </tr>
                            ) : (
                              templateCostOverrunProject
                            )
                          ) : (
                            (
                              <tr align="center">
                                <td>
                                  <NoDataFound />
                                </td>
                              </tr>
                            ) || null
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </DisplayByPermission>

              <div className="project-by project-by-sponsor">
                <div
                  className="mobile-heading"
                  onClick={() => this.taskStatusResult(2)}
                >
                  <h3>Projects by Sponsor</h3>
                </div>
                <div
                  className={`pending-tasks-inner popover-wrapper ${
                    taskStatus === 2 ? "link-display" : ""
                  }`}
                >
                  {" "}
                  <div className="dashboard-heading-wrapper popover-title">
                    <div
                      className="back-btn"
                      onClick={() => this.taskStatusResult(2)}
                    />
                    <h3>Projects by Sponsor</h3>

                    <Form className="project-by-filters">
                      {/* <Form.Group className="field-select">
                        <Form.Control
                          value={projectGroupCategorySelect}
                          as="select"
                          onChange={this.onSelectChange}
                          name="projectGroupCategorySelect"
                        >
                          <option selected value="CENTRAL">
                            Central
                          </option>
                          <option value="STATE">State</option>
                        </Form.Control>
                      </Form.Group> */}
                      <CustomDropdown
                        options={this.state.projectStatus.map(item => ({
                          value: item.value,
                          label: item.label
                        }))}
                        onChange={this.onSelectChangeDropdown}
                        width={"113px"}
                        height={"43px"}
                        className={"dashboard"}
                        page={"dashboard-projectbysponsor"}
                        menuClassName={"dashboardMenu"}
                        marginRight={"10px"}
                      />
                      <div className="dashboard-new-dropdown">
                        <Dropdown
                          key={panelKey}
                          options={filtersDropDown}
                          optionLabel="displayName"
                          className="project-by-sponsor"
                          value={projectStatusSelect}
                          onChange={e => this.projectStatusSelect(e)}
                          name="projectStatusSelect"
                          onHide={this.handleHide}
                          placeholder="All"
                          appendTo="self"
                        />
                      </div>
                      {/* <Form.Group className="field-select">
                        <Form.Control
                          value={projectStatusSelect}
                          as="select"
                          onChange={this.onSelectChange}
                          name="projectStatusSelect"
                        >
                          {filtersDropDown.map(val => (
                            <option value={val.key}>{val.displayName}</option>
                          ))}
                        </Form.Control>
                      </Form.Group> */}
                    </Form>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="1">
                          {this.state.sponsorGroupCategoryName}
                        </th>
                        <th
                          className={`sort-by ${
                            sortProjectOrder ? sortProjectOrder : "asc"
                          }`}
                          onClick={() =>
                            this.sortData("sortProjectOrder", "sortProjectCost")
                          }
                        >
                          Project(s)
                        </th>
                        <th
                          className={`sort-by ${
                            sortProjectCost ? sortProjectCost : "asc"
                          }`}
                          onClick={() =>
                            this.sortData("sortProjectCost", "sortProjectOrder")
                          }
                        >
                          Value (Cr)
                        </th>
                      </tr>
                    </thead>
                    {(projectsByDataStatus === STATUS.LOADING && (
                      <TableLoaderTemplate
                        height={60}
                        children={<IssuePendingLoader />}
                      />
                    )) || (
                      <tbody>
                        {isValidArray(projectsByData) ? (
                          isEmptyProject ? (
                            <tr align="center">
                              <td>
                                <NoDataFound />
                              </td>
                            </tr>
                          ) : (
                            templateProjectBy
                          )
                        ) : (
                          (
                            <tr align="center">
                              <td>
                                <NoDataFound />
                              </td>
                            </tr>
                          ) || null
                        )}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>

              {/* Added project By locations section here */}
              <div className="project-by project-by-location">
                <div
                  className="mobile-heading"
                  onClick={() => this.taskStatusResult(2)}
                >
                  <h3>Projects by Location</h3>
                </div>
                <div
                  className={`pending-tasks-inner popover-wrapper ${
                    taskStatus === 2 ? "link-display" : ""
                  }`}
                >
                  {" "}
                  <div className="dashboard-heading-wrapper popover-title">
                    <div
                      className="back-btn"
                      onClick={() => this.taskStatusResult(2)}
                    />
                    <h3>Projects by Location</h3>
                    <Form className="project-by-filters">
                      <CustomDropdown
                        options={this.state.projectLocationDropdown.map(
                          item => ({
                            value: item.value,
                            label: item.label
                          })
                        )}
                        onChange={this.onSelectChangeLocation}
                        width={"113px"}
                        height={"43px"}
                        className={"dashboard"}
                        page={"dashboard-projectbylocation"}
                        menuClassName={"dashboardMenu"}
                        marginRight={"10px"}
                      />
                      {/* <Form.Group className="field-select">
                        <Form.Control
                          value={projectLocationGroupCategorySelect}
                          as="select"
                          onChange={this.onSelectChange}
                          name="projectLocationGroupCategorySelect"
                        >
                          <option selected value="CENTRAL">
                            Central
                          </option>
                          <option value="STATE">State</option>
                        </Form.Control>
                      </Form.Group> */}
                      <div className="dashboard-new-dropdown">
                        <Dropdown
                          key={panelKey}
                          options={filtersDropDown}
                          optionLabel="displayName"
                          className="project-by-sponsor"
                          value={projectLocationStatusSelect}
                          onChange={e => this.projectLocationStatusSelect(e)}
                          name="projectLocationStatusSelect"
                          onHide={this.handleHide}
                          placeholder="All"
                          appendTo="self"
                        />
                      </div>
                      {/* <Form.Group className="field-select">
                        <Form.Control
                          value={projectLocationStatusSelect}
                          as="select"
                          onChange={this.onSelectChange}
                          name="projectLocationStatusSelect"
                        >
                          {filtersDropDown.map(val => (
                            <option value={val.key}>{val.displayName}</option>
                          ))}
                        </Form.Control>
                      </Form.Group> */}
                    </Form>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="1">
                          {this.state.locationGroupCategoryName}
                        </th>
                        <th
                          className={`sort-by ${
                            sortProjectLocationOrder
                              ? sortProjectLocationOrder
                              : "asc"
                          }`}
                          onClick={() =>
                            this.sortData(
                              "sortProjectLocationOrder",
                              "sortProjectLocationCost"
                            )
                          }
                        >
                          Project(s)
                        </th>
                        <th
                          className={`sort-by ${
                            sortProjectLocationCost
                              ? sortProjectLocationCost
                              : "asc"
                          }`}
                          onClick={() =>
                            this.sortData(
                              "sortProjectLocationCost",
                              "sortProjectLocationOrder"
                            )
                          }
                        >
                          Value (Cr)
                        </th>
                      </tr>
                    </thead>
                    {(projectsByLocationDataStatus === STATUS.LOADING && (
                      <TableLoaderTemplate
                        height={60}
                        children={<IssuePendingLoader />}
                      />
                    )) || (
                      <tbody>
                        {isValidArray(projectsByLocationData) ? (
                          isEmptyProject ? (
                            <tr align="center">
                              <td>
                                <NoDataFound />
                              </td>
                            </tr>
                          ) : (
                            templateProjectByLocation
                          )
                        ) : (
                          (
                            <tr align="center">
                              <td>
                                <NoDataFound />
                              </td>
                            </tr>
                          ) || null
                        )}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>

              {/* Removed meetings section from here and placed instead of notifications section */}
              {/* Removed Teams section from here */}
              {/* {showTeamSectionData ? (
                <div>
                  <div
                    className="mobile-heading"
                    onClick={() => this.taskStatusResult(8)}
                  >
                    <h3>Teams</h3>
                  </div>
                  <GroupSection
                    isLoading={childIssueStatus}
                    listingData={childIssueData}
                    taskStatus={taskStatus}
                    taskStatusResult={() => this.taskStatusResult}
                  />
                </div>
              ) : null} */}

              <div
                className={`${
                  issuesStatusSelect === "UNDER_PROCESS"
                    ? "issues-on-under-process"
                    : ""
                } issues-on even`}
              >
                <div
                  className="mobile-heading"
                  onClick={() => this.taskStatusResult(4)}
                >
                  <h3>Issues Pending with Recipients</h3>
                </div>
                <div
                  className={`pending-tasks-inner popover-wrapper ${
                    taskStatus === 4 ? "link-display" : ""
                  }`}
                >
                  {" "}
                  {/* popover-visible */}
                  <div className="dashboard-heading-wrapper popover-title">
                    <div
                      className="back-btn"
                      onClick={() => this.taskStatusResult(4)}
                    />
                    <h3>Issues Pending with Recipients</h3>
                    <Form className="issues-on-filters">
                      <CustomDropdown
                        options={this.state.projectStatus.map(item => ({
                          value: item.value,
                          label: item.label
                        }))}
                        onChange={this.onSelectChangeIssueGroup}
                        width={"113px"}
                        height={"43px"}
                        className={"dashboard"}
                        page={"dashboard-issuepending"}
                        menuClassName={"dashboardMenu"}
                        marginRight={"10px"}
                      />
                      {/* <Form.Group className="field-select">
                        <Form.Control
                          value={issuesGroupCategorySelect}
                          as="select"
                          onChange={this.onSelectChange}
                          name="issuesGroupCategorySelect"
                        >
                           <option value="">All</option> 
                          <option value="CENTRAL">Central</option>
                          <option value="STATE">State</option>
                        </Form.Control>
                      </Form.Group> */}
                      <div className="dashboard-new-dropdown">
                        <Dropdown
                          key={panelKey}
                          value={issuesStatusSelect}
                          onChange={e => this.onIssuesStatusSelect(e)}
                          name="issuesStatusSelect"
                          options={workflowStates
                            .filter(val => {
                              return issuesGroupCategorySelect
                                ? val.type.includes(issuesGroupCategorySelect)
                                : true;
                            })
                            .map(val => ({
                              label: val.name,
                              value: val.category
                            }))}
                          optionLabel="label"
                          className="issue-pending-recipient-dropdown"
                          onHide={this.handleHide}
                          disabled={!isValidArray(issuesByData)}
                          appendTo="self"
                          //  placeholder="Select Status"
                        />
                      </div>

                      {/* <Form.Group className="field-select">
                        <Form.Control
                          value={issuesStatusSelect}
                          as="select"
                          onChange={this.onIssuesStatusSelect}
                          name="issuesStatusSelect"
                          disabled={!isValidArray(issuesByData)}
                        >
                          {workflowStates
                            .filter(val => {
                              return issuesGroupCategorySelect
                                ? val.type.includes(issuesGroupCategorySelect)
                                : true;
                            })
                            .map(val => {
                              return (
                                <option value={val.category}>{val.name}</option>
                              );
                            })}
                        </Form.Control>
                      </Form.Group> */}
                    </Form>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>{this.state.issuesGroupCategoryName}</th>
                        <th
                          className={`sort-by ${
                            this.state.totalIssueCount
                              ? this.state.totalIssueCount
                              : "asc"
                          }`}
                          onClick={() =>
                            this.sortIssueRecipientData("totalIssueCount", [
                              "issueStatusCount",
                              "pastCompletionDate"
                            ])
                          }
                        >
                          Total Issues
                        </th>
                        <th
                          className={`sort-by ${
                            this.state.issueStatusCount
                              ? this.state.issueStatusCount
                              : "asc"
                          }`}
                          onClick={() =>
                            this.sortIssueRecipientData("issueStatusCount", [
                              "totalIssueCount",
                              "pastCompletionDate"
                            ])
                          }
                        >
                          {issuesStatusSelectText &&
                          issuesStatusSelectText !== ""
                            ? issuesStatusSelectText
                            : "Status"}
                        </th>
                        {issuesStatusSelect === "UNDER_PROCESS" ? (
                          <th
                            className={`sort-by ${
                              this.state.pastCompletionDate
                                ? this.state.pastCompletionDate
                                : "asc"
                            }`}
                            onClick={() =>
                              this.sortIssueRecipientData(
                                "pastCompletionDate",
                                ["totalIssueCount", "issueStatusCount"]
                              )
                            }
                          >
                            Issues Not Complied
                          </th>
                        ) : null}
                      </tr>
                    </thead>
                    <div className="dashboard-cards">
                      {(issuesByDataStatus === STATUS.LOADING && (
                        <TableLoaderTemplate
                          height={60}
                          children={<IssuePendingLoader />}
                        />
                      )) || (
                          <tbody>
                            {isValidArray(issuesByData) ? (
                              sortBy(
                                issuesByData,
                                sortRecipientKey,
                                this.state[sortRecipientKey]
                              ).map((issue, idx) => {
                                const summaryDataBy =
                                  issuesGroupCategorySelect === "STATE";
                                const state = {
                                  [issue.filterName]: [
                                    {
                                      key: get(issue, "groupId").toString(),
                                      displayName: get(issue, "groupName"),
                                      checked: true
                                    }
                                  ],
                                  groupCategory:
                                    issuesGroupCategorySelect === "STATE"
                                      ? "STATE"
                                      : "CENTRAL",
                                  projectFlags: checkedValue
                                    ? [
                                        {
                                          displayName: "MARCH 24",
                                          key: "MARCH 24"
                                        }
                                      ]
                                    : null,
                                  stages: issuesStatusSelect
                                    ? workflowStates.filter(
                                        val =>
                                          val.category == issuesStatusSelect
                                      )
                                    : []
                                };

                                return get(issue, "totalIssueCount") !== 0 ? (
                                  <tr key={`list-key-${idx}`}>
                                    {/* <td>
                                      <Image
                                        src={
                                          get(issue, "imageUrl", null) ||
                                          MinistryIcon
                                        }
                                        alt="Road Icon"
                                      />
                                    </td> */}
                                    <td>
                                      <Link
                                        to={{
                                          pathname: PATHS.ISSUE_LIST,
                                          isDashBoard: true,
                                          summaryDataBy,
                                          state
                                        }}
                                        className="dashboard-link-tags"
                                      >
                                        {get(issue, "groupName", "NA")}
                                      </Link>
                                    </td>
                                    <td>{get(issue, "totalIssueCount", 0)}</td>
                                    <td>{get(issue, "issueStatusCount", 0)}</td>
                                    {issuesStatusSelect === "UNDER_PROCESS" ? (
                                      <td>
                                        {get(issue, "pastCompletionDate", 0)}
                                      </td>
                                    ) : null}
                                  </tr>
                                ) : null;
                              })
                            ) : (
                              <tr align="center">
                                <td colSpan="3">
                                  <NoDataFound />
                                </td>
                              </tr>
                            )}
                          </tbody>
                        ) ||
                        null}
                    </div>
                    {/*</PerfectScrollbar>*/}
                  </table>
                </div>
              </div>
              {/* Instead of notifications place meetings section here */}
              {/* <Notification
                //notificationData={myNotificationData}
                //issueList={issueList}
                //isLoading={notificationStatus === STATUS.LOADING}
                setStatus={() => this.taskStatusResult(3)}
                taskStatus={taskStatus}
              /> */}
              {permission && !permission.dashboardMeetings ? (
                <div className="meetings odd">
                  <div
                    className="mobile-heading"
                    onClick={() => this.taskStatusResult(5)}
                  >
                    <h3>Upcoming Meetings</h3>
                  </div>
                  <div
                    className={`pending-tasks-inner popover-wrapper ${
                      taskStatus === 5 ? "link-display" : ""
                    }`}
                  >
                    {" "}
                    {/* popover-visible */}
                    <div className="dashboard-heading-wrapper popover-title">
                      <div
                        className="back-btn"
                        onClick={() => this.taskStatusResult(5)}
                      />
                      <h3>Upcoming Meetings</h3>
                      <div className="today-date" />
                    </div>
                    <div className="meetings-content">
                      {(upcomingMeetingStatus === STATUS.LOADING && (
                        <LoaderTemplate
                          height={80}
                          children={<MeetingLoaderTemplate />}
                        />
                      )) ||
                        (isValidArray(upcomingMeeting) ? (
                          upcomingMeeting.map((meetingsOnDate, key) => {
                            let meetingsDate =
                              meetingsOnDate.meetingDate &&
                              dateFormat(new Date(meetingsOnDate.meetingDate));
                            let todayDate = dateFormat(Date.now());
                            return (
                              <div className="meetings-date" key={key}>
                                <h4>
                                  {todayDate === meetingsDate
                                    ? "Today"
                                    : meetingsDate || "NA"}
                                </h4>
                                <ul>
                                  {isValidArray(meetingsOnDate.meetingDTOS) &&
                                    meetingsOnDate.meetingDTOS.map(
                                      (meeting, meetingKey) => {
                                        return (
                                          <li key={meetingKey}>
                                            <li
                                              key={meetingKey}
                                              class="meeting-container"
                                            >
                                              <div className="meeting-content">
                                                <b>
                                                  Agenda ID #{meeting.id} |{" "}
                                                  {meeting.meetingName}
                                                </b>
                                                on{" "}
                                                <span className="orange">
                                                  {dateFormatWithTime(
                                                    meeting.time
                                                  )}
                                                </span>
                                                @{meeting.venue}
                                              </div>
                                            </li>
                                          </li>
                                        );
                                      }
                                    )}
                                </ul>
                              </div>
                            );
                          })
                        ) : (
                          <NoDataFound />
                        ))}
                    </div>
                  </div>
                </div>
              ) : (
                <React.Fragment />
              )}
              {permission && permission.dashboardMeetings ? (
                <div className="meetings odd">
                  <div
                    className="mobile-heading"
                    onClick={() => this.taskStatusResult(5)}
                  >
                    <h3>Meetings</h3>
                  </div>
                  <div
                    className={`pending-tasks-inner popover-wrapper ${
                      taskStatus === 5 ? "link-display" : ""
                    }`}
                  >
                    {" "}
                    <div
                      className="dashboard-heading-wrapper popover-title"
                      style={{ marginBottom: "10px" }}
                    >
                      <div
                        className="back-btn"
                        onClick={() => this.taskStatusResult(5)}
                      />
                      <h3>
                        Meetings (
                        {isValidArray(get(meetingsData, "data")) &&
                          get(meetingsData, "data", []).length}
                        )
                      </h3>
                      <div className="today-date" />
                    </div>
                    <div
                      className="meetings-content"
                      style={{ paddingBottom: "0px", maxHeight: "528px" }}
                    >
                      {(meetingsAPIStatus === STATUS.LOADING && (
                        <LoaderTemplate
                          height={80}
                          children={<MeetingLoaderTemplate />}
                        />
                      )) ||
                        (isValidArray(get(meetingsData, "data")) ? (
                          get(meetingsData, "data").map(
                            (meetingsOnDate, key) => {
                              let meetingsDate =
                                meetingsOnDate.meetingDate &&
                                dateFormat(
                                  new Date(meetingsOnDate.meetingDate)
                                );
                              let todayDate = dateFormat(Date.now());
                              let tomorrow = dateFormat(
                                Date.now() + 24 * 60 * 60 * 1000
                              );
                              return (
                                <>
                                  {isValidArray(
                                    get(
                                      meetingsOnDate,
                                      "dashboardMeetingDataDTOList"
                                    )
                                  ) &&
                                    get(
                                      meetingsOnDate,
                                      "dashboardMeetingDataDTOList"
                                    ).map((meeting, meetingKey) => {
                                      let timeFromHours =
                                        (meeting.meetingTimeFrom &&
                                          new Date(
                                            meeting.meetingTimeFrom
                                          ).getHours()) ||
                                        "NA";
                                      let timeFromMinutes = meeting.meetingTimeFrom
                                        ? new Date(
                                            meeting.meetingTimeFrom
                                          ).getMinutes()
                                        : "NA";
                                      let timeToHours =
                                        (meeting.meetingTimeTo &&
                                          new Date(
                                            meeting.meetingTimeTo
                                          ).getHours()) ||
                                        "NA";
                                      let timeToMinutes = meeting.meetingTimeTo
                                        ? new Date(
                                            meeting.meetingTimeTo
                                          ).getMinutes()
                                        : "NA";
                                      return (
                                        <div className="parent-child">
                                          <div className="meeting-wrapper-part">
                                            <div>
                                              <img
                                                src={calBlank}
                                                alt="calendar"
                                              />
                                              <span className="date-fil">
                                                {todayDate === meetingsDate
                                                  ? "Today"
                                                  : tomorrow === meetingsDate
                                                  ? "Tomorrow"
                                                  : meetingsDate}
                                              </span>
                                            </div>
                                            <div>
                                              <img src={clockCal} alt="clock" />
                                              <span className="date-fil">
                                                {timeFromHours +
                                                  ":" +
                                                  ((timeFromMinutes < 10
                                                    ? "0"
                                                    : "") +
                                                    timeFromMinutes)}{" "}
                                                {timeFromHours > 12
                                                  ? "PM"
                                                  : "AM"}{" "}
                                                -{" "}
                                                {timeToHours +
                                                  ":" +
                                                  ((timeToMinutes < 10
                                                    ? "0"
                                                    : "") +
                                                    timeToMinutes)}{" "}
                                                {timeToHours > 12 ? "PM" : "AM"}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="meeting-wrapper-part-1">
                                            <div className="calNew" />
                                            <div style={{ width: "87%" }}>
                                              {meeting.clickable ? (
                                                <Link
                                                  to={{
                                                    pathname:
                                                      meeting.meetingStatus ===
                                                      "DRAFT"
                                                        ? PATHS.CREATE_AGENDA
                                                        : PATHS.AGENDA_DETAILS,
                                                    search: `?agendaId=${get(
                                                      meeting,
                                                      "agendaId",
                                                      "NA"
                                                    )}`,
                                                    state: {
                                                      agendaId: meeting.agendaId
                                                    }
                                                  }}
                                                  // className="dashboard-link-tags"
                                                  style={{ color: "#000" }}
                                                >
                                                  <div className="padding-meeting-agenda">
                                                    AGENDA
                                                    <span className="agendaId">
                                                      {" "}
                                                      #{meeting.agendaId}
                                                    </span>{" "}
                                                    |
                                                    <span className="projectCount">
                                                      {" "}
                                                      {
                                                        meeting.projectCount
                                                      }{" "}
                                                      Project(s) &{" "}
                                                      {meeting.issuesCount}{" "}
                                                      Issue(s)
                                                    </span>
                                                  </div>
                                                </Link>
                                              ) : (
                                                <div className="padding-meeting-agenda">
                                                  AGENDA
                                                  <span>
                                                    {" "}
                                                    #{meeting.agendaId}
                                                  </span>{" "}
                                                  |
                                                  <b>
                                                    {" "}
                                                    {meeting.projectCount}{" "}
                                                    Project(s) &{" "}
                                                    {meeting.issuesCount}{" "}
                                                    Issue(s)
                                                  </b>
                                                </div>
                                              )}
                                              <div
                                                className="meeting-venue p-left"
                                                style={{
                                                  maxWidth: this.maxWidth(
                                                    zoomPercentage
                                                  )
                                                }}
                                              >
                                                {meeting.venueName}
                                              </div>
                                              <div
                                                className="flex-bottom-part"
                                                style={{
                                                  width: this.width(
                                                    zoomPercentage
                                                  ),
                                                  gap: this.gridGap(
                                                    zoomPercentage
                                                  )
                                                }}
                                              >
                                                <div
                                                  className="d-flex dashboard-meeting-by"
                                                  style={{
                                                    width: this.chairedWidth(
                                                      zoomPercentage
                                                    )
                                                  }}
                                                >
                                                  <span>
                                                    <Image
                                                      src={Meeting}
                                                      style={{
                                                        marginRight: "7px"
                                                      }}
                                                    />
                                                  </span>
                                                  <div>
                                                    <span>
                                                      <b>Meeting Type</b>
                                                      <br />
                                                      {meeting.meetingType
                                                        ? meeting.meetingType
                                                        : "NA"}
                                                    </span>
                                                  </div>
                                                </div>
                                                <div
                                                  className="d-flex dashboard-meeting-by"
                                                  style={{
                                                    width: this.chairedWidth(
                                                      zoomPercentage
                                                    )
                                                  }}
                                                >
                                                  <span>
                                                    <Image
                                                      src={ChairedBy}
                                                      style={{
                                                        marginRight: "7px"
                                                      }}
                                                    />
                                                  </span>
                                                  <div>
                                                    <span
                                                      style={{
                                                        overflowWrap:
                                                          "anywhere",
                                                        whiteSpace: this.spacebreak(
                                                          zoomPercentage
                                                        )
                                                      }}
                                                    >
                                                      <b>Chaired by</b>
                                                      <br />
                                                      {meeting.meetingChairedBy
                                                        ? meeting.meetingChairedBy
                                                        : "NA"}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </>
                              );
                            }
                          )
                        ) : (
                          <NoDataFound />
                        ))}
                    </div>
                  </div>
                </div>
              ) : (
                <React.Fragment />
              )}

              <div className="project-by-scheme even">
                <div
                  className="mobile-heading"
                  onClick={() => {
                    this.taskStatusResult(6);
                  }}
                >
                  <h3>PRAGATI Projects</h3>
                </div>
                <div
                  className={`pending-tasks-inner popover-wrapper ${
                    taskStatus === 6 ? "link-display" : ""
                  }`}
                >
                  {" "}
                  <div className="dashboard-heading-wrapper popover-title">
                    <div
                      className="back-btn dropdown-awrapper"
                      onClick={() => {
                        this.taskStatusResult(6);
                      }}
                    />
                    <h3>PRAGATI Projects</h3>
                    <Form className="project-by-filters">
                      <CustomDropdown
                        options={this.state.projectStatus.map(item => ({
                          value: item.value,
                          label: item.label
                        }))}
                        onChange={this.onSelectChangePragatiProject}
                        width={"113px"}
                        height={"43px"}
                        className={"dashboard"}
                        page={"dashboard-pragatiprojects"}
                        menuClassName={"dashboardMenu"}
                        marginRight={"10px"}
                      />
                      {/* <Form.Group className="field-select">
                        <Form.Control
                          value={pragatiProjectSelectBy}
                          as="select"
                          onChange={this.onSelectChange}
                          name="pragatiProjectSelectBy"
                        >
                          <option value="">All</option> 
                          <option value="CENTRAL">Central</option>
                          <option value="STATE">State</option>
                        </Form.Control>
                      </Form.Group> */}
                      <CustomDropdown
                        options={filtersDropDown.map(item => ({
                          value: item.value,
                          label: item.displayName
                        }))}
                        fetchGetPragatiProject={this.fetchGetPragatiProject}
                        width={"200px"}
                        height={"43px"}
                        className={"dashboard"}
                        page={"dashboard"}
                        menuClassName={"dashboardMenu"}
                      />
                      {/* <Form.Group className="field-select select-border">
                        <Form.Control
                          value={prgatiProjectStatusSelect}
                          as="select"
                          onChange={this.onSelectChange}
                          name="prgatiProjectStatusSelect"
                        >
                          {filtersDropDown.map(val => (
                            <option value={val.key}>{val.displayName}</option>
                          ))}
                        </Form.Control>
                      </Form.Group> */}
                    </Form>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>{this.state.pragatiGroupCategoryName}</th>
                        <th
                          className={`sort-by ${
                            sortProjectScheme ? sortProjectScheme : "asc"
                          }`}
                          onClick={() =>
                            this.sortData(
                              "sortProjectScheme",
                              "sortProjectSchemeValue"
                            )
                          }
                        >
                          Projects
                        </th>
                        <th
                          className={`sort-by ${
                            sortProjectSchemeValue
                              ? sortProjectSchemeValue
                              : "asc"
                          }`}
                          onClick={() =>
                            this.sortData(
                              "sortProjectSchemeValue",
                              "sortProjectScheme"
                            )
                          }
                        >
                          Value (Cr)
                        </th>
                      </tr>
                    </thead>
                    {(projectsByPragatiDataStatus === STATUS.LOADING && (
                      <TableLoaderTemplate
                        height={50}
                        children={<IssuePendingLoader />}
                      />
                    )) || (
                      <tbody>
                        {isValidArray(projectsByPragatiData)
                          ? sortBy(
                              projectsByPragatiData,
                              sortProjectScheme
                                ? "projectStatusCount"
                                : "projectCost",
                              sortProjectSchemeValue || sortProjectScheme
                            ).map(pragati => {
                              return (
                                <tr key={pragati.groupName}>
                                  {/* <td>
                                    <Image
                                      src={
                                        get(pragati, "imageUrl", null) ||
                                        MinistryIcon
                                      }
                                      alt="Icon"
                                    />
                                  </td> */}
                                  <td>
                                    <Link
                                      className="dashboard-link-tags"
                                      to={{
                                        pathname: PATHS.PROJECT_LIST,
                                        isDashBoard: true,
                                        summaryDataBy:
                                          pragatiProjectSelectBy === "STATE",
                                        state: {
                                          projectFlags: [
                                            checkedValue
                                              ? {
                                                  displayName: "MARCH 24",
                                                  key: "MARCH 24"
                                                }
                                              : null,
                                            {
                                              key: "PRAGATI",
                                              displayName: "PRAGATI"
                                            }
                                          ].filter(Boolean),
                                          ...(pragatiProjectSelectBy === "STATE"
                                            ? {
                                                groupCategory: "STATE",
                                                sponsoringDepartment: [
                                                  {
                                                    key: get(
                                                      pragati,
                                                      "groupId"
                                                    ).toString(),
                                                    displayName: get(
                                                      pragati,
                                                      "groupName"
                                                    )
                                                  }
                                                ]
                                              }
                                            : {
                                                groupCategory: "CENTRAL",
                                                sponsoringMinistry: [
                                                  {
                                                    key: get(
                                                      pragati,
                                                      "groupId"
                                                    ).toString(),
                                                    displayName: get(
                                                      pragati,
                                                      "groupName"
                                                    )
                                                  }
                                                ]
                                              }),
                                          projectStage: prgatiProjectStatusSelect
                                            ? filtersDropDown.filter(
                                                val =>
                                                  val.key ===
                                                  prgatiProjectStatusSelect
                                              )
                                            : []
                                        }
                                      }}
                                    >
                                      {get(pragati, "groupName", "NA")}
                                    </Link>
                                  </td>
                                  <td>
                                    {get(pragati, "projectStatusCount", 0)}
                                  </td>

                                  <td>
                                    &#8377;{" "}
                                    {get(pragati, "projectCost")
                                      ? parseInt(get(pragati, "projectCost", 0))
                                      : null}{" "}
                                    Cr.
                                  </td>
                                </tr>
                              );
                            })
                          : (
                              <tr align="center">
                                <td colSpan="3">
                                  <NoDataFound />
                                </td>
                              </tr>
                            ) || null}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>

              <div className="issue-by-category odd issues-category">
                <div
                  className="mobile-heading"
                  onClick={() => this.taskStatusResult(7)}
                >
                  <h3>Pending Issues by Category</h3>
                </div>
                <div
                  className={`pending-tasks-inner popover-wrapper ${
                    taskStatus === 7 ? "link-display" : ""
                  }`}
                >
                  {" "}
                  <div className="dashboard-heading-wrapper popover-title">
                    <div
                      className="back-btn"
                      onClick={() => this.taskStatusResult(7)}
                    />
                    <h3>Pending Issues by Category</h3>
                    <Form className="project-by-filters">
                      <CustomDropdown
                        options={this.state.projectStatus.map(item => ({
                          value: item.value,
                          label: item.label
                        }))}
                        onChange={this.onSelectChangeIssuePendingCategory}
                        width={"113px"}
                        height={"43px"}
                        className={"dashboard"}
                        page={"dashboard-pendingissue-category"}
                        menuClassName={"dashboardMenu"}
                      />
                      {/* <Form.Group className="field-select">
                        <Form.Control
                          value={issuesByCategorySelectBy}
                          as="select"
                          onChange={this.onSelectChange}
                          name="issuesByCategorySelectBy"
                        >
                         <option value="">All</option>
                          <option value="CENTRAL">Central</option>
                          <option value="STATE">State</option>
                        </Form.Control>
                      </Form.Group> */}
                    </Form>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="2">Category</th>
                        <th
                          className={`sort-by ${
                            sortIssueCategoryCount
                              ? sortIssueCategoryCount
                              : "asc"
                          }`}
                          onClick={() =>
                            this.sortData("sortIssueCategoryCount", null)
                          }
                        >
                          Issue
                        </th>
                      </tr>
                    </thead>
                    {(issuesByCategoryDataStatus === STATUS.LOADING && (
                      <TableLoaderTemplate
                        height={60}
                        width={450}
                        times={8}
                        children={<IssueCategoryLoader />}
                      />
                    )) || (
                      <tbody>
                        {isValidArray(issuesByCategoryData)
                          ? sortBy(
                              issuesByCategoryData,
                              "issuesCount",
                              sortIssueCategoryCount
                            ).map((issue, key) => {
                              return (
                                <tr key={key}>
                                  <td>
                                    <Link
                                      className="dashboard-link-tags"
                                      to={{
                                        pathname: PATHS.ISSUE_LIST,
                                        isDashBoard: true,
                                        summaryDataBy: false,
                                        state: {
                                          category: [
                                            {
                                              key: get(
                                                issue,
                                                "categoryId"
                                              ).toString(),
                                              displayName: get(
                                                issue,
                                                "category"
                                              )
                                            }
                                          ],
                                          projectFlags: checkedValue
                                            ? [
                                                {
                                                  displayName: "MARCH 24",
                                                  key: "MARCH 24"
                                                }
                                              ]
                                            : null,
                                          ...(issuesByCategorySelectBy ===
                                          "STATE"
                                            ? {
                                                groupCategory: "STATE",
                                                stages: ISSUE_STAGES_STATE
                                              }
                                            : {
                                                groupCategory: "CENTRAL",
                                                stages: ISSUE_STAGES_CENTRAL
                                              }),
                                          projectStage: [
                                            {
                                              key: "VERIFIED",
                                              displayName: "VERIFIED"
                                            }
                                          ]
                                        }
                                      }}
                                    >
                                      {get(issue, "category", "NA")}
                                    </Link>
                                  </td>
                                  <td>{get(issue, "issuesCount", 0)}</td>
                                </tr>
                              );
                            })
                          : (
                              <tr align="center">
                                <td colSpan="2">
                                  <NoDataFound />
                                </td>
                              </tr>
                            ) || null}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDashboardSummary,
      getProjectsByScheme,
      getIssuesByCategory,
      getIssuesByCategoryForGanttChart,
      getPendingIssuesBy,
      getProjectsBy,
      getProjectsByLocation,
      fetchMeetings,
      getDashboardNotifications,
      getIssueList,
      getPragatiProjectList,
      getDownloadDashboardSummaryAction,
      clearDashboardSummaryAction,
      getDashboardUpcomingMeetings,
      getChildGroupIssuesData,
      getDashboardPendingTasksAction,
      showTeamSection,
      downloadWeeklyReportForStatePmg,
      clearWeeklyReportForStatePmgAction,
      getDelayedProjectsList,
      getProjectsCostOverRunList,
      getPmgMeetingStatusAction,
      _getProjectsByCompletionStageAction,
      downloadMarch24ReportExcelAction,
      clearDownloadMarch24ReportExcelAction
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    projectList: state.commonReducer.projectList,
    summaryData: state.dashboardReducer.summaryData,
    summaryDataStatus: state.dashboardReducer.summaryDataStatus,

    projectsByPragatiData: state.dashboardReducer.projectsByPragatiData,
    projectsByPragatiDataStatus:
      state.dashboardReducer.projectsByPragatiDataStatus,

    delayedProjectData: state.dashboardReducer.delayedProjectData,
    delayedProjectStatus: state.dashboardReducer.delayedProjectStatus,

    issuesByCategoryData: state.dashboardReducer.issuesByCategoryData,
    issuesByCategoryDataStatus:
      state.dashboardReducer.issuesByCategoryDataStatus,

    issuesByCategoryGanttChartData:
      state.dashboardReducer.issuesByCategoryGanttChartData,
    issuesByCategoryGanttChartDataStatus:
      state.dashboardReducer.issuesByCategoryGanttChartDataStatus,

    issuesByData: state.dashboardReducer.issuesByData,
    issuesByDataStatus: state.dashboardReducer.issuesByDataStatus,

    projectsByData: state.dashboardReducer.projectsByData,
    projectsByDataStatus: state.dashboardReducer.projectsByDataStatus,

    projectsByLocationData: state.dashboardReducer.projectsByLocationData,
    projectsByLocationDataStatus:
      state.dashboardReducer.projectsByLocationDataStatus,

    meetingsData: state.dashboardReducer.meetingsData,
    meetingsAPIStatus: state.dashboardReducer.meetingsAPIStatus,

    notificationData: state.dashboardReducer.notificationData,
    notificationStatus: state.dashboardReducer.notificationStatus,

    issueList: state.commonReducer.issueList,
    dashboardSummaryReducer: state.donwloadExcelReducer.dashboardSummary,
    march24ReportReducer: state.donwloadExcelReducer.march24Report,

    upcomingMeetingStatus: state.dashboardReducer.upcomingMeetingStatus,
    upcomingMeeting: state.dashboardReducer.upcomingMeeting,

    childIssueStatus: state.dashboardReducer.childIssueStatus,
    childIssueData: state.dashboardReducer.childIssueData,

    pendingTaskLoading: state.dashboardReducer.pendingTaskLoading,
    pendingTask: state.dashboardReducer.pendingTask,

    showTeamSectionData: state.dashboardReducer.showTeamSection,
    statePmgReportReducer: state.donwloadExcelReducer.weeklyReportForStatePmg,
    isDesktopView: state.commonReducer.isDesktopView,

    costOverrunProjectData: state.dashboardReducer.costOverrunProjectData,
    costOverrunProjectStatus: state.dashboardReducer.costOverrunProjectStatus,

    getPmgMeetingData: state.dashboardReducer.getPmgMeetingData,
    getPmgMeetingStatus: state.dashboardReducer.getPmgMeetingStatus,

    getProjectStagesForGraphsData:
      state.dashboardReducer.getProjectStagesForGraphsData,
    getProjectStagesForGraphsStatus:
      state.dashboardReducer.getProjectStagesForGraphsStatus
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PermissionHoc(Dashboard))
);
